var catalog_product =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(287);
	__webpack_require__(219);
	__webpack_require__(288);
	__webpack_require__(290);
	__webpack_require__(96);
	__webpack_require__(93);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(321);
	__webpack_require__(325);
	__webpack_require__(130);
	__webpack_require__(156);
	__webpack_require__(337);
	__webpack_require__(339);
	__webpack_require__(222);
	__webpack_require__(204);
	__webpack_require__(340);
	__webpack_require__(342);
	__webpack_require__(347);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(94);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	__webpack_require__(147);
	__webpack_require__(149);
	
	var event = new _trackerEvents2['default']();
	event.onShowProductCard();
	
	$('#toogle_open').click(function () {
	    $('.li_toogle').css('display', 'list-item');
	    $('.li_toogle').addClass('li_toogle_close');
	    $('#toogle_open').css('display', 'none');
	    $('#toogle_close').css('display', 'block');
	});
	$('#toogle_close').click(function () {
	    $('.li_toogle').css('display', 'none');
	    $('.li_toogle').removeClass('li_toogle_close');
	    $('#toogle_open').css('display', 'block');
	    $('#toogle_close').css('display', 'none');
	});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _tracker = __webpack_require__(140);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	Element.prototype.parents = function (selector) {
	    var elements = [];
	    var elem = this;
	    var ishaveselector = selector !== undefined;
	
	    while ((elem = elem.parentElement) !== null) {
	        if (elem.nodeType !== Node.ELEMENT_NODE) {
	            continue;
	        }
	
	        if (!ishaveselector || elem.matches(selector)) {
	            elements.push(elem);
	        }
	    }
	
	    return elements;
	};
	
	var Events = (function () {
	    function Events() {
	        _classCallCheck(this, Events);
	
	        this.searchData = [];
	    }
	
	    _createClass(Events, [{
	        key: 'init',
	        value: function init() {
	            var self = this;
	            this.onClickSoc();
	            this.onClickCity();
	            this.onClickSocIcon();
	            this.onClickProductTabs();
	            this.onClickProductPdf();
	            this.onClickPhone();
	            this.onClickTabs();
	            this.showMainBanner();
	            this.showSpecBanner();
	            this.onClickMainPromo();
	            this.onShowWatched();
	            this.onShowAnalog();
	            this.onClickProductCatalogBlock();
	            this.onClickWatched();
	            this.onClickAnalog();
	            this.onShowCatalogProducts();
	
	            setTimeout(function () {
	                self.onShowNewProducts();
	                self.onClickNewProducts();
	            }, 1000);
	        }
	    }, {
	        key: 'onClickSoc',
	        value: function onClickSoc() {
	            $('body').on('click', '.footer__column--social a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickTabs',
	        value: function onClickTabs() {
	            $('body').on('click', '.tabs__tab--cloud', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickPhone',
	        value: function onClickPhone() {
	            $('body').on('click', '.city-data-block__phones-link', function (e) {
	                var trackers = new _tracker2['default']();
	                trackers.onPMbtnTel();
	            });
	        }
	    }, {
	        key: 'onClickProductTabs',
	        value: function onClickProductTabs() {
	            $('body').on('click', '.product-card__tabs .tabs__tab', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickProductPdf',
	        value: function onClickProductPdf() {
	            $('body').on('click', '.product-card__previews-item--pdf', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickPdf(data);
	            });
	        }
	    }, {
	        key: 'onClickSocIcon',
	        value: function onClickSocIcon() {
	            $('body').on('click', '.bottom-menu__text-contacts-icon', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickCity',
	        value: function onClickCity() {
	            $('body').on('click', '.cities-list .cities-list__item a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent({
	                    event: 'PMbtnSelectCity',
	                    param: data.code
	                });
	            });
	        }
	
	        /**
	         * ловим события баннера на главной странице
	         */
	    }, {
	        key: 'showMainBanner',
	        value: function showMainBanner() {
	            var localBanners = [];
	            var self = this;
	            $('.js-slick-fullwidth-slider').on('init', function (event, slick) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'showSpecBanner',
	        value: function showSpecBanner() {
	            var localBanners = [];
	            var specBanners = document.querySelectorAll('.block-list--promos a.tiles__item--promo');
	            var self = this;
	
	            specBanners.forEach(function (element, index) {
	                var banner = {
	                    id: element.dataset.id,
	                    name: element.dataset.name,
	
	                    position: 'slot' + index
	                };
	                var bannerId = self.sendItemBanner(localBanners, banner, 'indexBannerSpec');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'sendItemBanner',
	        value: function sendItemBanner(localBanners, activeBanner, name) {
	            if (activeBanner !== undefined) {
	                if (localBanners.indexOf(activeBanner.id) === -1) {
	                    var _trackers = new _tracker2['default']();
	                    _trackers.onViewPromo({
	                        promoView: {
	                            promotions: [{
	                                id: activeBanner.id,
	                                name: name,
	                                creative: activeBanner.name,
	                                position: activeBanner.position
	                            }]
	                        }
	                    });
	                    localBanners.push(activeBanner.id);
	                    return activeBanner.id;
	                }
	            }
	        }
	    }, {
	        key: 'onClickMainPromo',
	        value: function onClickMainPromo() {
	            $('body').on('click', '.block-list.block-list--promos a', function (e) {
	                var dataId = this.getAttribute('data-id');
	                var dataName = this.getAttribute('data-name');
	                var trackers = new _tracker2['default']();
	                var dataNumber = 0;
	                if (this.parentNode.classList.contains('tiles__item--action-content')) {
	                    dataNumber = parseInt($(this.parentNode.parentNode).index()) + 1;
	                } else {
	                    dataNumber = parseInt($(this).index()) + 1;
	                }
	                trackers.onClickPromo({
	                    promoClick: {
	                        promotions: [{
	                            id: dataId,
	                            name: dataName,
	                            creative: 'banner' + dataNumber,
	                            position: 'slot' + dataNumber
	                        }]
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.products-slider .products-slider__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'newProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowNewProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowWatched',
	        value: function onShowWatched() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.also-viewed .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowWatchedProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowAnalog',
	        value: function onShowAnalog() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.site-block .tabs__content .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowAnalogProducts({
	                    impressions: productData
	                });
	            }
	        }
	
	        /**
	         * отображение каталога, отправляем пачками по 8 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowCatalogProducts',
	        value: function onShowCatalogProducts() {
	            var products = [];
	            var productNodes = document.querySelectorAll('.catalog #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 8 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (products.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 8);
	                                    var productsList = [];
	
	                                    products.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'catalogProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	
	        /**
	         * отображение каталога в поиске, отправляем пачками по 10 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowSearchProducts',
	        value: function onShowSearchProducts() {
	            var productNodes = document.querySelectorAll('.search_container #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 10 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (self.searchData.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 10);
	                                    var productsList = [];
	
	                                    self.searchData.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'searchProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'onClickProductCatalogBlock',
	        value: function onClickProductCatalogBlock() {
	            var self = this;
	
	            $('.grid.catalog .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'catalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'catalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickProductSearchBlock',
	        value: function onClickProductSearchBlock() {
	            var self = this;
	            $('.search_container .grid .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    list: 'searchProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'searchProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'searchProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var self = this;
	            $('.also-viewed.grid .product').on('click', 'a, img', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.also-viewed .grid__item') + 1;
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'WatchedProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickWatched({
	                    click: {
	                        actionField: {
	                            list: 'WatchedProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var self = this;
	            $('.site-block .tabs__content .grid__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.site-block .tabs__content .grid__item') + 1;
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'AnalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickAnalog({
	                    click: {
	                        actionField: {
	                            list: 'AnalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var self = this;
	            $('.products-slider .products-slider__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.products-slider__item')[0]).index('.products-slider .products-slider__item') + 1;
	                var product = _extends({
	                    list: 'newProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'newProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickNewProducts({
	                    click: {
	                        actionField: {
	                            list: 'newProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var self = this;
	            if ($('.product-card').length > 0) {
	                var productDom = $('.product-card')[0];
	                var _productData = self.prepareData(productDom);
	                var product = _extends({}, _productData);
	
	                var _trackers2 = new _tracker2['default']();
	                _trackers2.onShowProductCard({
	                    detail: {
	                        actionField: {
	                            list: localStorage.getItem('list')
	                        }
	                    },
	                    products: [product]
	                });
	            }
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var self = this;
	            var productDom = $('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({}, productData);
	
	            var trackers = new _tracker2['default']();
	            trackers.onShowProductCardPopup({
	                detail: {
	                    actionField: {
	                        list: localStorage.getItem('list')
	                    }
	                },
	                products: [product]
	            });
	        }
	    }, {
	        key: 'onAddToCardProduct',
	        value: function onAddToCardProduct(elem) {
	            //проверяем откуда клик на добавление в корзину (карточка, списки)
	            if (elem.hasClass('product-card__btn')) {
	                this.addToCardFromCard(elem);
	            } else {
	                this.addToCardFromList(elem);
	            }
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard(elem) {
	            var self = this;
	            var productDom = elem.parents('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({
	                quantity: 1
	            }, productData);
	            var trackers = new _tracker2['default']();
	            trackers.addToCardFromCard({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList(elem) {
	            var self = this;
	            var productDom = elem.parents('.product')[0];
	            var position = 0;
	            var list = '';
	            var productData = self.prepareData(productDom);
	
	            if (elem.parents('.catalog #catalog__products').length > 0) {
	                list = 'catalogProducts';
	                position = $(elem.parents('.grid__item')).index('#catalog__products .grid__item') + 1;
	            } else if (elem.parents('.slick-track').length > 0) {
	                list = 'newProducts';
	                position = $(elem.parents('.products-slider__item')).index('.slick-track .products-slider__item') + 1;
	            } else if (elem.parents('div[data-tab="analogs"]').length > 0) {
	                list = 'AnalogProducts';
	                position = $(elem.parents('.grid__item')).index('div[data-tab="analogs"] .grid__item') + 1;
	            } else if (elem.parents('.also-viewed').length > 0) {
	                list = 'WatchedProducts';
	                position = $(elem.parents('.grid__item')).index('.also-viewed .grid__item') + 1;
	            } else if (elem.parents('.search_container').length > 0) {
	                list = 'searchProducts';
	                position = $(elem.parents('.grid__item')).index('.search_container .grid__item') + 1;
	            }
	            var trackers = new _tracker2['default']();
	
	            var product = _extends({
	                list: list,
	                position: position
	            }, productData);
	
	            trackers.onClickCatalogProducts({
	                click: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({}, productData);
	
	            trackers.onShowProductCard({
	                detail: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({
	                quantity: 1
	            }, productData);
	
	            trackers.addToCardFromList({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'onClickCartAddProduct',
	        value: function onClickCartAddProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityChange - quantityOld
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickAddProduct({
	                    add: {
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onClickCartRemoveProduct',
	        value: function onClickCartRemoveProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityOld - quantityChange
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickRemoveProduct({
	                    remove: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1(data) {
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	
	        /**
	         * подгоовка данных
	         * @param elem
	         * @returns {{price: number, name: string, category: number, brand: number}}
	         */
	    }, {
	        key: 'prepareData',
	        value: function prepareData(elem) {
	            var name = '';
	            if (elem.querySelector('[data-name]') !== null && elem.querySelector('[data-name]').dataset.name !== undefined) {
	                name = elem.querySelector('[data-name]').dataset.name;
	            }
	
	            var productId = '';
	            if (elem.querySelector('[data-product-id]') !== null && elem.querySelector('[data-product-id]').dataset.productId !== undefined) {
	                productId = elem.querySelector('[data-product-id]').dataset.productId;
	            }
	
	            var price = 0;
	            if (elem.querySelector('[data-price]') !== null && elem.querySelector('[data-price]').dataset.price !== undefined) {
	                price = elem.querySelector('[data-price]').dataset.price;
	            }
	
	            var brand = 0;
	            if (elem.querySelector('[data-brand]') !== null && elem.querySelector('[data-brand]').dataset.brand !== undefined) {
	                brand = elem.querySelector('[data-brand]').dataset.brand;
	            }
	
	            var category = 0;
	            if (elem.querySelector('[data-category]') !== null && elem.querySelector('[data-category]').dataset.category !== undefined) {
	                category = elem.querySelector('[data-category]').dataset.category;
	            }
	
	            return {
	                name: name,
	                price: price,
	                brand: brand,
	                category: category,
	                id: productId
	            };
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep(param) {
	            var step = 1;
	            if (param) {
	                step = param;
	            }
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var products = document.querySelectorAll('.cart .cart__item.basket__cart__item.cart__item--checkout');
	            products.forEach(function (item, index) {
	                var name = '';
	                if (item.getAttribute('data-product-name') !== null && item.getAttribute('data-product-name') !== undefined) {
	                    name = item.getAttribute('data-product-name');
	                }
	
	                var price = 0;
	                if (item.getAttribute('data-product-price') !== null && item.getAttribute('data-product-price') !== undefined) {
	                    price = item.getAttribute('data-product-price');
	                }
	
	                var brand = 0;
	                if (item.getAttribute('data-product-brand') !== null && item.getAttribute('data-product-brand') !== undefined) {
	                    brand = item.getAttribute('data-product-brand');
	                }
	
	                var category = 0;
	                if (item.getAttribute('data-product-category') !== null && item.getAttribute('data-product-category') !== undefined) {
	                    category = item.getAttribute('data-product-category');
	                }
	
	                var quantity = 0;
	                if (item.querySelectorAll('.quantity__value')[0].value !== null && item.querySelectorAll('.quantity__value')[0].value !== undefined) {
	                    quantity = item.querySelectorAll('.quantity__value')[0].value;
	                }
	
	                var product = {
	                    name: name,
	                    id: item.getAttribute('data-product-id'),
	                    price: price,
	                    brand: brand,
	                    category: category,
	                    quantity: quantity
	                };
	
	                productData.push(product);
	            });
	
	            if (productData.length > 0) {
	                trackers.onShowOrderStep({
	                    checkout: {
	                        actionField: {
	                            step: step
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }]);
	
	    return Events;
	})();
	
	exports['default'] = Events;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(59);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(136) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(69);
	var getKeys = __webpack_require__(76);
	var gOPS = __webpack_require__(137);
	var pIE = __webpack_require__(138);
	var toObject = __webpack_require__(139);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _gtm = __webpack_require__(141);
	
	var _gtm2 = _interopRequireDefault(_gtm);
	
	var _fbpixel = __webpack_require__(142);
	
	var _fbpixel2 = _interopRequireDefault(_fbpixel);
	
	var _mailru = __webpack_require__(143);
	
	var _yandexMetrika = __webpack_require__(144);
	
	//import { MindboxTracker } from '../../modules/mindbox/mindbox-tracker';
	
	__webpack_require__(145);
	__webpack_require__(146);
	
	var Trackers = (function () {
	    function Trackers() {
	        var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Trackers);
	
	        this.data = arg;
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	        this.instances = {
	            gtm: new _gtm2['default'](),
	            fbpixel: new _fbpixel2['default']()
	        };
	        if (!arg.onlyTrackers) {
	            return;
	        }
	
	        for (var track in this.instances) {
	            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
	                delete this.instances[track];
	            }
	        }
	    }
	
	    _createClass(Trackers, [{
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            this.mailru = new _mailru.MailRuTracker();
	            var route = $('.main-container').data('route');
	
	            switch (route) {
	                case 'index':
	                    this.indexPageViewed();
	                    break;
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	                case 'order':
	                    this.orderPageViewed();
	                    break;
	                case 'search':
	                    this.searchPageViewed();
	                    break;
	                default:
	                    this.otherPageViewed();
	                    break;
	            }
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            this.yandexMetrika.userAuthorized(user);
	        }
	    }, {
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length <= 0 || arguments[0] === undefined ? 190000 : arguments[0];
	
	            var _self = this;
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'trigger',
	        value: function trigger(evType, arg) {
	            for (var instName in this.instances) {
	                if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
	                    this.instances[instName][evType](arg[instName]);
	                }
	            }
	        }
	    }, {
	        key: 'getTracker',
	        value: function getTracker(tracker) {
	            return this.instances[tracker];
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToCart', arg);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToFav', arg);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSearch', arg);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onContentView', arg);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUp', arg);
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUpEnd', arg);
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutStart', arg);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutEnd', arg);
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserWindow', arg);
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserReply', arg);
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('claimButton', arg);
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onTabClick', arg);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscribe', arg);
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscriptionDone', arg);
	            this.trigger('onPMfrmSubscribe', arg);
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackFormShow', arg);
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackButton', arg);
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackRequestSend', arg);
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onBasketRefresh', arg);
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyButton', arg);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyEnd', arg);
	        }
	    }, {
	        key: 'onPMbtnTel',
	        value: function onPMbtnTel() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnTel', arg);
	        }
	    }, {
	        key: 'onPMbtnFilter',
	        value: function onPMbtnFilter() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFilter', arg);
	        }
	    }, {
	        key: 'onClickEvent',
	        value: function onClickEvent() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onClickPdf',
	        value: function onClickPdf() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFavorite',
	        value: function onPMbtnFavorite() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFavorite', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtnAddToCart',
	        value: function onPMbtnAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAddToCart', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtn1Click',
	        value: function onPMbtn1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtn1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMfrm1Click',
	        value: function onPMfrm1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrm1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFAQ',
	        value: function onPMbtnFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFAQ', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMeContact',
	        value: function onPMfrmCallMeContact() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMeContact', arg);
	        }
	    }, {
	        key: 'onPMfrmFAQ',
	        value: function onPMfrmFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmFAQ', arg);
	        }
	    }, {
	        key: 'onPMbtnCallMe',
	        value: function onPMbtnCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMe',
	        value: function onPMfrmCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmReg',
	        value: function onPMfrmReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmReg', arg);
	        }
	    }, {
	        key: 'onPMbtnReg',
	        value: function onPMbtnReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnReg', arg);
	        }
	    }, {
	        key: 'onPMbtnComment',
	        value: function onPMbtnComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnComment', arg);
	        }
	    }, {
	        key: 'onPMfrmComment',
	        value: function onPMfrmComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmComment', arg);
	        }
	    }, {
	        key: 'onPMbtnAskQuestion',
	        value: function onPMbtnAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAskQuestion', arg);
	        }
	    }, {
	        key: 'onPMfrmAskQuestion',
	        value: function onPMfrmAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmAskQuestion', arg);
	        }
	    }, {
	        key: 'onClickPromo',
	        value: function onClickPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onViewPromo',
	        value: function onViewPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoView', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowWatchedProducts',
	        value: function onShowWatchedProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowAnalogProducts',
	        value: function onShowAnalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAddProduct',
	        value: function onClickAddProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickRemoveProduct',
	        value: function onClickRemoveProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceRemove', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowcatalogProducts',
	        value: function onShowcatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickCatalogProducts',
	        value: function onClickCatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'completeRegistration',
	        value: function completeRegistration() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('CompleteRegistration', arg);
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.mailru.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.mailru.categoryPageView();
	            //this.mindboxTracker.categoryView(this.data.category);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
	            //this.mindboxTracker.productView($('.js-vendor-code').data('vendor-code'));
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            this.mailru.otherPageView();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            this.mailru.searchPageView();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.mailru.orderPageView();
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            var ids = [];
	            var products = document.querySelectorAll('.cart__item .cart__item-content');
	            products.forEach(function (product) {
	                ids.push(product.getAttribute('data-product-id'));
	            });
	
	            this.mailru.basketPageView(ids, $('.basket-final-price').html());
	        }
	    }]);
	
	    return Trackers;
	})();
	
	exports['default'] = Trackers;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GTMEvents = (function () {
	    function GTMEvents() {
	        _classCallCheck(this, GTMEvents);
	
	        this.events = {
	            registrationDone: 'Registration_Done',
	            subscriptionButton: 'Subscription_Button',
	            subscriptionDone: 'Subscription_Done',
	            PMfrmSubscribe: 'PMfrmSubscribe',
	            add2CartButton: 'Add2Cart_Button',
	            oneClickBuyButton: 'oneClick_buy_Button',
	            accessoriesTab: 'accessories_tab',
	            faqTab: 'faq_tab',
	            reviewsTab: 'reviews_tab',
	            descriptionTab: 'description_tab',
	            onlineConsultant: 'online_consultant',
	            onlineConsultantButton: 'online_consultant_button',
	            onlineConsultantSent: 'online_consultant_sent',
	            backcall: 'backcall',
	            backcallButton: 'backcall_button',
	            backcallSent: 'backcall_sent',
	            claimButton: 'claim_button',
	            claimDone: 'claim_Done',
	            basketRefresh: 'basket_refresh',
	            basketOrder: 'basket_order',
	            contactLogin: 'contact_login',
	            contact1clickBuy: 'contact_1clickBuy',
	            contactRegistration: 'contact_registration',
	            contactRegistrationContinue: 'contact_registration_continue',
	            contactLoginContinue: 'contact_login_continue',
	            contact1clickBuyContinue: 'contact_1clickBuy_continue',
	            confirmOrder: 'confirm_order',
	            PMbtnSocial: 'PMbtnSocial',
	            PMbtnFAQ: 'PMbtnFAQ',
	            PMfrmFAQ: 'PMfrmFAQ',
	            PMbtnCallMe: 'PMbtnCallMe',
	            PMfrmCallMe: 'PMfrmCallMe',
	            PMbtnReg: 'PMbtnReg',
	            PMfrmReg: 'PMfrmReg',
	            PMbtnSelectCity: 'PMbtnSelectCity',
	            PMbtnTellAbout: 'PMbtnTellAbout',
	            PMbtnContact: 'PMbtnContact',
	            PMbtnComment: 'PMbtnComment',
	            PMfrmComment: 'PMfrmComment',
	            PMbtnAskQuestion: 'PMbtnAskQuestion',
	            PMfrmAskQuestion: 'PMfrmAskQuestion',
	            PMbtn1Click: 'PMbtn1Click',
	            PMfrm1Click: 'PMfrm1Click',
	            PMbtnFavorite: 'PMbtnFavorite',
	            PMbtnAddToCart: 'PMbtnAddToCart',
	            PMbtnTabs: 'PMbtnTabs',
	            PMbtnTel: 'PMbtnTel',
	            PMfrmCallMeContact: 'PMfrmCallMeContact',
	            PMbtnVariant: 'PMbtnVariant',
	            PMbtnFilter: 'PMbtnFilter',
	            ecommercePromoClick: 'ecommercePromoClick',
	            ecommercePromoView: 'ecommercePromoView',
	            ecommerceImpressions: 'ecommerceImpressions',
	            ecommerceClick: 'ecommerceClick',
	            ecommerceDetail: 'ecommerceDetail',
	            ecommerceAdd: 'ecommerceAdd',
	            ecommerceRemove: 'ecommerceRemove',
	            ecommerceCheckout: 'ecommerceCheckout',
	            completeRegistration: 'CompleteRegistration'
	        };
	    }
	
	    _createClass(GTMEvents, [{
	        key: 'onAddToCart',
	        value: function onAddToCart(arg) {
	            if (arg) {
	                this.push(_extends({
	                    event: 'addToCart'
	                }, arg));
	                return;
	            }
	            this.pushEvent('add2CartButton');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd(event) {
	            this.pushEvent(event);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            this.pushEvent('confirmOrder');
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            this.pushEvent('onlineConsultant');
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            this.pushEvent('onlineConsultantButton');
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            this.pushEvent('claimButton');
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick(tab) {
	            var tabMap = {
	                descr: 'descriptionTab',
	                reviews: 'reviewsTab',
	                faq: 'faqTab',
	                login: 'contactLogin',
	                reg: 'contactRegistration',
	                oneclick: 'contact1clickBuy'
	            };
	
	            if (!tabMap[tab]) {
	                return;
	            }
	
	            this.pushEvent(tabMap[tab]);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            this.pushEvent('subscriptionButton');
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            this.pushEvent('subscriptionDone');
	        }
	    }, {
	        key: 'onPMfrmSubscribe',
	        value: function onPMfrmSubscribe() {
	            this.pushEvent('PMfrmSubscribe');
	        }
	    }, {
	        key: 'PMbtnTel',
	        value: function PMbtnTel() {
	            this.pushEvent('PMbtnTel');
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            this.pushEvent('backcall');
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            this.pushEvent('backcallButton');
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            this.pushEvent('backcallSent');
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            this.pushEvent('basketOrder');
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            this.pushEvent('basketRefresh');
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            this.pushEvent('oneClickBuyButton');
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            this.pushEvent('contact1clickBuyContinue');
	        }
	    }, {
	        key: 'PMbtnSocial',
	        value: function PMbtnSocial(arg) {
	            this.push(_extends({
	                event: 'PMbtnSocial'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnVariant',
	        value: function PMbtnVariant(arg) {
	            this.push(_extends({
	                event: 'PMbtnVariant'
	            }, arg));
	        }
	    }, {
	        key: 'PMfrmCallMeContact',
	        value: function PMfrmCallMeContact(arg) {
	            this.push(_extends({
	                event: 'PMfrmCallMeContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTabs',
	        value: function PMbtnTabs(arg) {
	            this.push(_extends({
	                event: 'PMbtnTabs'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnAddToCart',
	        value: function PMbtnAddToCart(arg) {
	            this.push(_extends({
	                event: 'PMbtnAddToCart'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnSelectCity',
	        value: function PMbtnSelectCity(arg) {
	            this.push(_extends({
	                event: 'PMbtnSelectCity'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTellAbout',
	        value: function PMbtnTellAbout(arg) {
	            this.push(_extends({
	                event: 'PMbtnTellAbout'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtn1Click',
	        value: function PMbtn1Click() {
	            this.push({
	                event: 'PMbtn1Click'
	            });
	        }
	    }, {
	        key: 'PMfrm1Click',
	        value: function PMfrm1Click(arg) {
	            this.push(_extends({
	                event: 'PMfrm1Click'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFavorite',
	        value: function PMbtnFavorite(arg) {
	            this.push(_extends({
	                event: 'PMbtnFavorite'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnContact',
	        value: function PMbtnContact(arg) {
	            this.push(_extends({
	                event: 'PMbtnContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFAQ',
	        value: function PMbtnFAQ() {
	            this.push({
	                event: 'PMbtnFAQ'
	            });
	        }
	    }, {
	        key: 'PMfrmFAQ',
	        value: function PMfrmFAQ() {
	            this.push({
	                event: 'PMfrmFAQ'
	            });
	        }
	    }, {
	        key: 'PMbtnCallMe',
	        value: function PMbtnCallMe() {
	            this.push({
	                event: 'PMbtnCallMe'
	            });
	        }
	    }, {
	        key: 'PMfrmCallMe',
	        value: function PMfrmCallMe() {
	            this.push({
	                event: 'PMfrmCallMe'
	            });
	        }
	    }, {
	        key: 'PMbtnFilter',
	        value: function PMbtnFilter() {
	            this.push({
	                event: 'PMbtnFilter'
	            });
	        }
	    }, {
	        key: 'PMbtnReg',
	        value: function PMbtnReg() {
	            this.push({
	                event: 'PMbtnReg'
	            });
	        }
	    }, {
	        key: 'PMfrmReg',
	        value: function PMfrmReg() {
	            this.push({
	                event: 'PMfrmReg'
	            });
	        }
	    }, {
	        key: 'PMbtnComment',
	        value: function PMbtnComment() {
	            this.push({
	                event: 'PMbtnComment'
	            });
	        }
	    }, {
	        key: 'PMfrmComment',
	        value: function PMfrmComment() {
	            this.push({
	                event: 'PMfrmComment'
	            });
	        }
	    }, {
	        key: 'PMbtnAskQuestion',
	        value: function PMbtnAskQuestion() {
	            this.push({
	                event: 'PMbtnAskQuestion'
	            });
	        }
	    }, {
	        key: 'PMfrmAskQuestion',
	        value: function PMfrmAskQuestion() {
	            this.push({
	                event: 'PMfrmAskQuestion'
	            });
	        }
	    }, {
	        key: 'pushEvent',
	        value: function pushEvent(eventName) {
	            if (this.events[eventName] !== undefined) {
	                this.push({
	                    event: this.events[eventName]
	                });
	            }
	        }
	    }, {
	        key: 'ecommercePromoClick',
	        value: function ecommercePromoClick(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommercePromoView',
	        value: function ecommercePromoView(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoView'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceImpressions',
	        value: function ecommerceImpressions(arg) {
	            this.push(_extends({
	                event: 'ecommerceImpressions'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceClick',
	        value: function ecommerceClick(arg) {
	            this.push(_extends({
	                event: 'ecommerceClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceDetail',
	        value: function ecommerceDetail(arg) {
	            this.push(_extends({
	                event: 'ecommerceDetail'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceAdd',
	        value: function ecommerceAdd(arg) {
	            this.push(_extends({
	                event: 'ecommerceAdd'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceRemove',
	        value: function ecommerceRemove(arg) {
	            this.push(_extends({
	                event: 'ecommerceRemove'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceCheckout',
	        value: function ecommerceCheckout(arg) {
	            this.push(_extends({
	                event: 'ecommerceCheckout'
	            }, arg));
	        }
	    }, {
	        key: 'push',
	        value: function push(params) {
	            window.dataLayer.push(params);
	        }
	    }]);
	
	    return GTMEvents;
	})();
	
	exports['default'] = GTMEvents;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FBPixel = (function () {
	    function FBPixel() {
	        _classCallCheck(this, FBPixel);
	
	        var pageTitle = document.querySelector('h1');
	        this.title = pageTitle ? pageTitle.textContent : '';
	    }
	
	    _createClass(FBPixel, [{
	        key: 'track',
	        value: function track(type, args) {
	            if (typeof window.fbq !== 'function') {
	                return;
	            }
	            window.fbq('track', type, args);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView(location) {
	            var locations = ['categories', 'product', 'articles'];
	
	            if (locations.indexOf(location) === -1) {
	                return;
	            }
	
	            this.track('ViewContent', {
	                content_name: this.title
	            });
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart(args) {
	            this.withCurrency('InitiateCheckout', args);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd(args) {
	            this.withCurrency('Purchase', args);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd(args) {
	            this.onCheckoutEnd(args);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch(args) {
	            this.track('Search', args);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            this.track('Lead');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            this.withCurrency('CompleteRegistration', {
	                value: 100
	            });
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart(args) {
	            this.withCurrency('AddToCart', args);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav(args) {
	            this.withCurrency('AddToWishlist', _extends({}, args, {
	                content_name: this.title
	            }));
	        }
	    }, {
	        key: 'withCurrency',
	        value: function withCurrency(type) {
	            var args = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	            this.track(type, _extends({}, args, {
	                currency: 'RUB'
	            }));
	        }
	    }]);
	
	    return FBPixel;
	})();
	
	exports['default'] = FBPixel;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MailRuTracker = (function () {
	    function MailRuTracker() {
	        _classCallCheck(this, MailRuTracker);
	
	        this.init();
	    }
	
	    _createClass(MailRuTracker, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), { pagetype: 'home' }));
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView() {
	            this.push(this.getQueryTemplate());
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'category',
	                productid: '',
	                totalvalue: ''
	            }));
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(ids, totalPrice) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'cart',
	                productid: ids,
	                totalvalue: totalPrice
	            }));
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(id, price) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'product',
	                productid: id,
	                totalvalue: parseFloat(price)
	            }));
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'purchase'
	            }));
	        }
	    }, {
	        key: 'searchPageView',
	        value: function searchPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'searchresults'
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3241057',
	                type: 'itemView',
	                productid: '',
	                pagetype: 'other',
	                totalvalue: '',
	                list: '3'
	            };
	        }
	    }]);
	
	    return MailRuTracker;
	})();

	exports.MailRuTracker = MailRuTracker;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexMetrika = (function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                window.ym(911516, code, eventCode);
	            } catch (e) {
	                //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }]);
	
	    return YandexMetrika;
	})();

	exports.YandexMetrika = YandexMetrika;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*!
	Waypoints Inview Shortcut - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  function noop() {}
	
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/shortcuts/inview */
	  function Inview(options) {
	    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints = []
	    this.element = this.options.element
	    this.createWaypoints()
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoints = function() {
	    var configs = {
	      vertical: [{
	        down: 'enter',
	        up: 'exited',
	        offset: '100%'
	      }, {
	        down: 'entered',
	        up: 'exit',
	        offset: 'bottom-in-view'
	      }, {
	        down: 'exit',
	        up: 'entered',
	        offset: 0
	      }, {
	        down: 'exited',
	        up: 'enter',
	        offset: function() {
	          return -this.adapter.outerHeight()
	        }
	      }],
	      horizontal: [{
	        right: 'enter',
	        left: 'exited',
	        offset: '100%'
	      }, {
	        right: 'entered',
	        left: 'exit',
	        offset: 'right-in-view'
	      }, {
	        right: 'exit',
	        left: 'entered',
	        offset: 0
	      }, {
	        right: 'exited',
	        left: 'enter',
	        offset: function() {
	          return -this.adapter.outerWidth()
	        }
	      }]
	    }
	
	    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
	      var config = configs[this.axis][i]
	      this.createWaypoint(config)
	    }
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoint = function(config) {
	    var self = this
	    this.waypoints.push(new Waypoint({
	      context: this.options.context,
	      element: this.options.element,
	      enabled: this.options.enabled,
	      handler: (function(config) {
	        return function(direction) {
	          self.options[config[direction]].call(self, direction)
	        }
	      }(config)),
	      offset: config.offset,
	      horizontal: this.options.horizontal
	    }))
	  }
	
	  /* Public */
	  Inview.prototype.destroy = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].destroy()
	    }
	    this.waypoints = []
	  }
	
	  Inview.prototype.disable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].disable()
	    }
	  }
	
	  Inview.prototype.enable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].enable()
	    }
	  }
	
	  Inview.defaults = {
	    context: window,
	    enabled: true,
	    enter: noop,
	    entered: noop,
	    exit: noop,
	    exited: noop
	  }
	
	  Waypoint.Inview = Inview
	}())
	;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    isIOS: function isIOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
	    },
	    getBodyScrollTop: function getBodyScrollTop() {
	        return self.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop;
	    },
	    getBodyMiddlePos: function getBodyMiddlePos() {
	        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
	    },
	    //узнать настоящую полную высоту блока с заданным max-height
	    getTrueHeight: function getTrueHeight($block) {
	        var el = $block.clone().css({
	            height: 'auto',
	            width: $block.width(),
	            overflow: 'hidden',
	            'max-height': 'none'
	        }).insertAfter($block);
	
	        var trueHeight = el.outerHeight(true);
	        el.remove();
	
	        return trueHeight;
	    },
	    number_format: __webpack_require__(167),
	
	    setMaskedPhone: function setMaskedPhone($element) {
	        $element.mask('+7(999)999-99-99', { autoclear: false });
	    },
	    setMaskedPhoneCity: function setMaskedPhoneCity($element) {
	        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
	    },
	    setMaskedPhoneMobile: function setMaskedPhoneMobile($element) {
	        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
	    },
	
	    getCookie: function getCookie(name) {
	        var matches = document.cookie.match('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	    },
	
	    setCookie: function setCookie(name, value, options) {
	        options = options || {};
	
	        var expires = options.expires;
	
	        if (typeof expires == 'number' && expires) {
	            var d = new Date();
	            d.setTime(d.getTime() + expires * 1000);
	            expires = options.expires = d;
	        }
	        if (expires && expires.toUTCString) {
	            options.expires = expires.toUTCString();
	        }
	
	        value = encodeURIComponent(value);
	
	        var updatedCookie = name + '=' + value;
	
	        for (var propName in options) {
	            updatedCookie += '; ' + propName;
	            var propValue = options[propName];
	            if (propValue !== true) {
	                updatedCookie += '=' + propValue;
	            }
	        }
	
	        document.cookie = updatedCookie;
	    },
	    deleteCookie: function deleteCookie(name) {
	        var cookie_date = new Date();
	        cookie_date.setTime(cookie_date.getTime() - 1);
	        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
	    }
	};
	var initDadata = function initDadata() {
	    var streetInput = document.getElementById("street");
	    var cityInput = document.getElementById("city").value;
	    var token = 'b574f61916aa7f16b0ed0aaa318da372bfe05254';
	    var type = 'address';
	    var createSuggestions = window.Dadata.createSuggestions;
	
	    var regionSuggestions = createSuggestions(streetInput, {
	        token: token,
	        type: 'address',
	        hint: false,
	        count: 15,
	        params: {
	            from_bound: { value: 'street' },
	            to_bound: { value: 'street' },
	            locations: {
	                city: cityInput
	            },
	            language: 'ru', // Язык результатов
	            strict: true // Строгий поиск по точному совпадению
	        }
	    });
	    var citySuggestions = createSuggestions('', {
	        token: token,
	        type: type,
	        hint: false,
	        params: { from_bound: { value: "city" }, to_bound: { value: "settlement" } }
	    }, regionSuggestions);
	};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
	  // eslint-disable-line camelcase
	  //  discuss at: https://locutus.io/php/number_format/
	  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // improved by: davook
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Theriault (https://github.com/Theriault)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // bugfixed by: Michael White (https://getsprink.com)
	  // bugfixed by: Benjamin Lupton
	  // bugfixed by: Allan Jensen (https://www.winternet.no)
	  // bugfixed by: Howard Yeend
	  // bugfixed by: Diogo Resende
	  // bugfixed by: Rival
	  // bugfixed by: Brett Zamir (https://brett-zamir.me)
	  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  //  revised by: Luke Smith (https://lucassmith.name)
	  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
	  //    input by: Jay Klehr
	  //    input by: Amir Habibi (https://www.residence-mixte.com/)
	  //    input by: Amirouche
	  //   example 1: number_format(1234.56)
	  //   returns 1: '1,235'
	  //   example 2: number_format(1234.56, 2, ',', ' ')
	  //   returns 2: '1 234,56'
	  //   example 3: number_format(1234.5678, 2, '.', '')
	  //   returns 3: '1234.57'
	  //   example 4: number_format(67, 2, ',', '.')
	  //   returns 4: '67,00'
	  //   example 5: number_format(1000)
	  //   returns 5: '1,000'
	  //   example 6: number_format(67.311, 2)
	  //   returns 6: '67.31'
	  //   example 7: number_format(1000.55, 1)
	  //   returns 7: '1,000.6'
	  //   example 8: number_format(67000, 5, ',', '.')
	  //   returns 8: '67.000,00000'
	  //   example 9: number_format(0.9, 0)
	  //   returns 9: '1'
	  //  example 10: number_format('1.20', 2)
	  //  returns 10: '1.20'
	  //  example 11: number_format('1.20', 4)
	  //  returns 11: '1.2000'
	  //  example 12: number_format('1.2000', 3)
	  //  returns 12: '1.200'
	  //  example 13: number_format('1 000,50', 2, '.', ' ')
	  //  returns 13: '100 050.00'
	  //  example 14: number_format(1e-8, 8, '.', '')
	  //  returns 14: '0.00000001'
	
	  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	  var n = !isFinite(+number) ? 0 : +number;
	  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	  var s = '';
	
	  var toFixedFix = function toFixedFix(n, prec) {
	    if (('' + n).indexOf('e') === -1) {
	      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
	    } else {
	      var arr = ('' + n).split('e');
	      var sig = '';
	      if (+arr[1] + prec > 0) {
	        sig = '+';
	      }
	      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
	    }
	  };
	
	  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
	  if (s[0].length > 3) {
	    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	  }
	  if ((s[1] || '').length < prec) {
	    s[1] = s[1] || '';
	    s[1] += new Array(prec - s[1].length + 1).join('0');
	  }
	
	  return s.join(dec);
	};
	//# sourceMappingURL=number_format.js.map

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	jQuery(function () {
	    $('.soc-marks__link, .product-card__common-text .soc-square-btn').click(function () {
	        var data = this.dataset;
	        var trackers = new _trackerTracker2['default']();
	        trackers.onClickEvent(data);
	        var social_box = $(this).parent('div');
	        var count = parseInt($('span', social_box).text());
	        if (!isNaN(count)) {
	            count = count + 1;
	            $('span', social_box).text(count);
	        }
	        window.open($(this).attr('href'), 'displayWindow', 'width=700,' + 'height=400,' + 'left=200,' + 'top=100,' + 'location=no,' + 'directories=no,' + 'status=no,' + 'toolbar=no,' + 'menubar=no');
	        return false;
	    });
	});

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(220);
	
	jQuery(function () {
	    $(document).on('click', '.js-ripple', function (e) {
	        var $this = $(this);
	
	        var $offset = $this.offset();
	        var $circle = $this.find('.ripple__circle').removeClass('is-active');
	
	        if ($circle.length == 0) {
	            $this.append('<span class="ripple__circle"></span>');
	            $circle = $this.find('.ripple__circle');
	        }
	        var x = e.pageX - $offset.left;
	        var y = e.pageY - $offset.top;
	
	        $circle.css({
	            top: y + 'px',
	            left: x + 'px'
	        });
	
	        $this.addClass('ripple--active');
	
	        $this.on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function () {
	            $(this).removeClass('ripple--active');
	        });
	    });
	});

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	__webpack_require__(223);
	var functions = __webpack_require__(166);
	
	var Basket = (function () {
	    /**
	     * В конструктор передается изменямый элемент
	     * @param element {HTMLElement}
	     */
	
	    function Basket(element) {
	        _classCallCheck(this, Basket);
	
	        this.element = $(element);
	        this.curItem = this.element.closest('.cart__item');
	        this.alsoItems = this.curItem.find('.cart__also-items');
	    }
	
	    /**
	     * Анимация показать сопуствующие товары
	     */
	
	    _createClass(Basket, [{
	        key: 'animateShowAlso',
	        value: function animateShowAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', 0).addClass('cart__also-items--visible');
	
	            var trueHeight = functions.getTrueHeight(this.alsoItems);
	
	            this.alsoItems.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $alsoItems.addClass('no-transition').css('max-height', 'none');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').addClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').removeClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация скрыть сопуствующие товары
	         */
	    }, {
	        key: 'animateHideAlso',
	        value: function animateHideAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', this.alsoItems.height() + 'px');
	
	            setTimeout(function () {
	                $alsoItems.removeClass('no-transition').css('max-height', 0);
	            }, 25);
	
	            setTimeout(function () {
	                $alsoItems.removeClass('cart__also-items--visible');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').removeClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').addClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация удалить товар
	         */
	    }, {
	        key: 'animateDeleteProduct',
	        value: function animateDeleteProduct() {
	            var $curItem = this.curItem;
	            var $to = $('<div class="cart__item cart__item--empty" />').insertAfter(this.curItem);
	
	            this.curItem.width(this.curItem.width());
	
	            $to.height(this.curItem.height());
	            this.curItem.css('top', this.curItem.position().top).addClass('cart__item--abs cart__item--deleting');
	            $curItem.remove();
	            $to.animate({ height: 0 }, 350, function () {
	                $to.remove();
	            });
	        }
	
	        /**
	         * Ajax запрос на обновление количества товара в корзине
	         * @param productId {number} - Ид товара
	         * @param quantity {number} Количество
	         * @param parentProductId {number} Ид товара родителя у связанных товаров
	         */
	    }, {
	        key: 'updateProductQuantity',
	        value: function updateProductQuantity(productId, quantity, parentProductId) {
	            if (parentProductId == undefined) {
	                parentProductId = 0;
	            }
	            return $.ajax({
	                url: '/ajax/action/basket_add_popup/add_to_basket_ajax/',
	                data: 'PRODUCT_ID=' + productId + '&QUANTITY=' + quantity + '&PARENT_PRODUCT_ID=' + parentProductId
	            }).then(function (result) {
	                $('input[name="QUANTITY_' + productId + '"]').val(result.data['QUANTITY']);
	                window.updateMiniBasket();
	            });
	        }
	    }]);
	
	    return Basket;
	})();
	
	module.exports = Basket;
	
	jQuery(function () {
	    $(document).on('click', '.js-cart-show-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateShowAlso();
	    });
	
	    $(document).on('click', '.js-cart-hide-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateHideAlso();
	    });
	
	    $(document).on('click', '.js-delete-cart-item', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateDeleteProduct();
	    });
	});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(241)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(242)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var defined = __webpack_require__(81);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(59);
	var redefine = __webpack_require__(243);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(244);
	var $iterCreate = __webpack_require__(245);
	var setToStringTag = __webpack_require__(248);
	var getPrototypeOf = __webpack_require__(250);
	var ITERATOR = __webpack_require__(249)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(246);
	var descriptor = __webpack_require__(73);
	var setToStringTag = __webpack_require__(248);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(64)(IteratorPrototype, __webpack_require__(249)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(66);
	var dPs = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(90);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(71)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(247).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(60).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(65).f;
	var has = __webpack_require__(74);
	var TAG = __webpack_require__(249)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(60).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(74);
	var toObject = __webpack_require__(139);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(256);
	var ITERATOR = __webpack_require__(249)('iterator');
	var Iterators = __webpack_require__(244);
	module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(80);
	var TAG = __webpack_require__(249)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	var global = __webpack_require__(60);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(244);
	var TO_STRING_TAG = __webpack_require__(249)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(263);
	var step = __webpack_require__(264);
	var Iterators = __webpack_require__(244);
	var toIObject = __webpack_require__(78);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(242)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * jQuery serializeObject
	 * @copyright 2014, macek <paulmacek@gmail.com>
	 * @link https://github.com/macek/jquery-serialize-object
	 * @license BSD
	 * @version 2.5.0
	 */
	(function(root, factory) {
	
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(124)], __WEBPACK_AMD_DEFINE_RESULT__ = function(exports, $) {
	      return factory(exports, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // CommonJS
	  else if (typeof exports !== "undefined") {
	    var $ = require("jquery");
	    factory(exports, $);
	  }
	
	  // Browser
	  else {
	    factory(root, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	}(this, function(exports, $) {
	
	  var patterns = {
	    validate: /^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,
	    key:      /[a-z0-9_]+|(?=\[\])/gi,
	    push:     /^$/,
	    fixed:    /^\d+$/,
	    named:    /^[a-z0-9_]+$/i
	  };
	
	  function FormSerializer(helper, $form) {
	
	    // private variables
	    var data     = {},
	        pushes   = {};
	
	    // private API
	    function build(base, key, value) {
	      base[key] = value;
	      return base;
	    }
	
	    function makeObject(root, value) {
	
	      var keys = root.match(patterns.key), k;
	
	      // nest, nest, ..., nest
	      while ((k = keys.pop()) !== undefined) {
	        // foo[]
	        if (patterns.push.test(k)) {
	          var idx = incrementPush(root.replace(/\[\]$/, ''));
	          value = build([], idx, value);
	        }
	
	        // foo[n]
	        else if (patterns.fixed.test(k)) {
	          value = build([], k, value);
	        }
	
	        // foo; foo[bar]
	        else if (patterns.named.test(k)) {
	          value = build({}, k, value);
	        }
	      }
	
	      return value;
	    }
	
	    function incrementPush(key) {
	      if (pushes[key] === undefined) {
	        pushes[key] = 0;
	      }
	      return pushes[key]++;
	    }
	
	    function encode(pair) {
	      switch ($('[name="' + pair.name + '"]', $form).attr("type")) {
	        case "checkbox":
	          return pair.value === "on" ? true : pair.value;
	        default:
	          return pair.value;
	      }
	    }
	
	    function addPair(pair) {
	      if (!patterns.validate.test(pair.name)) return this;
	      var obj = makeObject(pair.name, encode(pair));
	      data = helper.extend(true, data, obj);
	      return this;
	    }
	
	    function addPairs(pairs) {
	      if (!helper.isArray(pairs)) {
	        throw new Error("formSerializer.addPairs expects an Array");
	      }
	      for (var i=0, len=pairs.length; i<len; i++) {
	        this.addPair(pairs[i]);
	      }
	      return this;
	    }
	
	    function serialize() {
	      return data;
	    }
	
	    function serializeJSON() {
	      return JSON.stringify(serialize());
	    }
	
	    // public API
	    this.addPair = addPair;
	    this.addPairs = addPairs;
	    this.serialize = serialize;
	    this.serializeJSON = serializeJSON;
	  }
	
	  FormSerializer.patterns = patterns;
	
	  FormSerializer.serializeObject = function serializeObject() {
	    return new FormSerializer($, this).
	      addPairs(this.serializeArray()).
	      serialize();
	  };
	
	  FormSerializer.serializeJSON = function serializeJSON() {
	    return new FormSerializer($, this).
	      addPairs(this.serializeArray()).
	      serializeJSON();
	  };
	
	  if (typeof $.fn !== "undefined") {
	    $.fn.serializeObject = FormSerializer.serializeObject;
	    $.fn.serializeJSON   = FormSerializer.serializeJSON;
	  }
	
	  exports.FormSerializer = FormSerializer;
	
	  return FormSerializer;
	}));


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var debounce = __webpack_require__(52);
	__webpack_require__(291);
	
	var heightLimit = __webpack_require__(293);
	
	jQuery(function () {
	    var trackers = new _trackerTracker2['default']();
	
	    $('.js-tabs').each(function () {
	        var $this = $(this);
	
	        var horizAnimation = $this.hasClass('js-tabs-horiz-anim');
	
	        var $tabs = $this.find('.tabs__tab');
	        var $contentBlocks = $this.find('.tabs__content');
	        var $contentBlocksParent = $this.find('.tabs__content-holder');
	
	        var $curContentBlock = $contentBlocks.filter('.tabs__content--current');
	
	        if (horizAnimation) {
	            $contentBlocks.not($curContentBlock).css('left', '100%').hide();
	            $contentBlocks.addClass('tabs__content--anim');
	            $curContentBlock.css('left', 0).show();
	        }
	
	        $tabs.click(function (e) {
	            e.preventDefault();
	
	            if ($this.hasClass('js-tabs-animated')) return;
	
	            var $curTab = $(this);
	            var tabName = $curTab.data('tab');
	
	            if ($curTab.hasClass('tabs__tab--current')) return;
	
	            var $curContentBlock = $contentBlocks.filter('.tabs__content--current');
	            var $newContentBlock = $contentBlocks.filter('[data-tab=' + tabName + ']');
	
	            if (horizAnimation) {
	                $this.addClass('js-tabs-animated');
	                $contentBlocksParent.css('min-height', $curContentBlock.height()).css('overflow', 'hidden');
	                var direction = $curContentBlock.index() > $newContentBlock.index() ? 'right' : 'left';
	
	                $curContentBlock.css('left', direction == 'right' ? '100%' : '-100%');
	                $newContentBlock.css('left', direction == 'right' ? '-100%' : '100%');
	
	                var newBlockHeight = $newContentBlock.height();
	
	                setTimeout(function () {
	                    $contentBlocksParent.addClass('tabs__content-holder--anim').css('min-height', newBlockHeight);
	                }, 30);
	            }
	
	            $tabs.removeClass('tabs__tab--current tabs__tab--prev');
	            $curTab.addClass('tabs__tab--current');
	
	            //класс "предыдущий" нужен в целях дизайна
	            $curTab.prev().addClass('tabs__tab--prev');
	
	            $contentBlocks.removeClass('tabs__content--current');
	
	            if (horizAnimation) {
	                $newContentBlock.show().css('left', 0);
	
	                $newContentBlock.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
	                    $this.removeClass('js-tabs-animated');
	                });
	
	                setTimeout(function () {
	                    $curContentBlock.hide();
	                    $newContentBlock.addClass('tabs__content--current');
	                    heightLimit.checkHeightLimitBlock($newContentBlock.find('.js-height-limit'));
	                    $contentBlocksParent.removeAttr('style');
	                    $contentBlocksParent.removeClass('tabs__content-holder--anim');
	                }, 550);
	            } else {
	                $newContentBlock.addClass('tabs__content--current');
	            }
	
	            trackers.onTabClick({ gtm: $newContentBlock.data('tab') });
	        });
	    });
	
	    //если при ресайзе внезапно оказывается, что текущий таб скрыт,
	    //то покажем первый попавшийся другой.
	    //например, "комплексная покупка" отсутствует на мобилках
	    debounce.setResizeDebounce(function () {
	        $('.js-tabs').each(function () {
	            var $this = $(this);
	            var $tabs = $this.find('.tabs__tab');
	            var $contentBlocks = $this.find('.tabs__content');
	
	            var $curContentBlock = $contentBlocks.filter('.tabs__content--current');
	
	            if (!$curContentBlock.is(':visible')) {
	                var curTabName = $curContentBlock.data('tab');
	
	                if (window.location.hash !== '') {
	                    var hashCode = window.location.hash.replace(new RegExp('#', 'g'), '');
	                    $('[data-tab=' + hashCode + ']').click();
	                } else {
	                    $tabs.not('[data-tab=' + curTabName + ']').first().click();
	                }
	            }
	        });
	    });
	
	    /* для данных страниц вкладки не переключаем */
	    var notChangePage = ['/search/'];
	    /* получаем якорь и в зависимости от него показываем нужную вкладку */
	    if (window.location.hash !== '') {
	        var curPath = window.location.pathname;
	        if (notChangePage.indexOf(curPath) == -1) {
	            var tab = false;
	            var hashCode = window.location.hash.replace(new RegExp('#', 'g'), '');
	            /* проверяем реально ли существует такая вкладка */
	            if ($('.tabs__tab[data-tab="' + hashCode + '"]').length) {
	                tab = hashCode;
	            }
	            if (tab) {
	                $.each($('.tabs__content'), function (e, selector) {
	                    $(selector).removeClass('tabs__content--current');
	                    $(selector).hide().css('left', '100%');
	                    if ($(selector).data('tab') === tab) {
	                        $(selector).addClass('tabs__content--current');
	                        $(selector).show().css('left', 0);
	                    }
	                });
	                $.each($('.tabs__tab'), function (e, selector) {
	                    $(selector).removeClass('tabs__tab--current');
	                    if ($(selector).data('tab') === tab) {
	                        $(selector).addClass('tabs__tab--current');
	                    }
	                });
	            }
	        }
	    }
	
	    $(window).resize();
	});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(294);
	
	var functions = __webpack_require__(166);
	
	jQuery(function ($) {
	    var checkHeightLimitBlock = function checkHeightLimitBlock($block) {
	        if ($block == undefined) $block = $('.js-height-limit');
	
	        //блок должен быть Jquery объектом а не какой-то левой фигней
	        if ($block.bind !== $.prototype.bind) $block = $('.js-height-limit');
	
	        if ($block.length == 0) return;
	
	        if (!$block.hasClass('js-height-limit')) return;
	
	        $block.each(function () {
	            var $this = $(this);
	            if ($this.hasClass('height-limit--full')) return;
	
	            if (!$this.is(':visible')) return;
	
	            var maxHeight = parseInt($this.css('max-height'));
	            $this.removeClass('height-limit--visible');
	
	            if ($this.innerHeight() < maxHeight) $this.addClass('height-limit--visible');
	        });
	    };
	
	    $(document).on('click', '.js-height-limit-more', function (e) {
	        e.preventDefault();
	        var $block = $(this).closest('.height-limit');
	        var trueHeight = functions.getTrueHeight($block);
	
	        if ($block.hasClass('height-limit--full')) {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.removeAttr('style');
	                $block.removeClass('no-transition');
	            }, 25);
	
	            setTimeout(function () {
	                $block.removeClass('height-limit--full');
	            }, 400);
	        } else {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.addClass('height-limit--full no-transition').css('max-height', 'none');
	            }, 400);
	        }
	    });
	
	    debounce.setResizeDebounce(checkHeightLimitBlock);
	
	    module.exports.checkHeightLimitBlock = checkHeightLimitBlock;
	});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */,
/* 296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesYandexSmartCaptchaYandexSmartCaptcha = __webpack_require__(299);
	
	__webpack_require__(300);
	
	var form = __webpack_require__(318);
	
	jQuery(function () {
	    new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('detail_element_add_reviews_captcha').init();
	    var addReviewFormHtml = $('.js-review-add_container').html();
	    /**
	     *  Отзывы
	     * @type {{addReview: {html: *, submit: function(*, *, *): void}}}
	     */
	    var addReviewPrompt = {
	        addReview: {
	            html: addReviewFormHtml,
	
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $this = $(this);
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        review_name: { required: true },
	                        review_city: { required: true },
	                        review_activity: { required: true },
	                        review_rating: {},
	                        question_comment: {}
	                    },
	                    messages: {
	                        review_name: { required: 'Не указано имя' },
	                        review_city: { required: 'Не указан город' },
	                        review_activity: {
	                            required: 'Не указан род деятельности'
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/reviews/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                if (result.code === 200) {
	                                    var trackers = new _trackerTracker2['default']();
	                                    trackers.onPMfrmComment();
	                                    $.prompt.getState('addReview').find('.form').html('<p>' + result.html + '</p>');
	                                } else {
	                                    var errorDiv = $('<div/>', {
	                                        'class': 'form__error-msg',
	                                        text: result.data.error
	                                    });
	                                    $this.find('.form__head-label').after(errorDiv);
	                                }
	                            }
	                        });
	                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                        // чтобы не казалось, будто он совсем пропал с экрана
	                        $.prompt.position();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	
	    /**
	     * Вопрос ответ
	     * @type {{addQuestion: {html: string, submit: function(*, *, *): void}}}
	     */
	    var addQuestionPrompt = {
	        addQuestion: {
	            html: '',
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $this = $(this);
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        question_name: { required: true },
	                        question_email: { required: true, email: true },
	                        question_phone: { required: true, phoneMask: true },
	                        question_city: { required: true },
	                        question_activity: { required: true }
	                    },
	                    messages: {
	                        question_name: { required: 'Не указано имя' },
	                        question_city: { required: 'Не указан город' },
	                        question_activity: {
	                            required: 'Не указан род деятельности'
	                        },
	                        question_email: {
	                            required: $.validator.messages.EMAIL.required,
	                            email: $.validator.messages.EMAIL.email
	                        },
	                        question_phone: {
	                            required: $.validator.messages.PHONE.required,
	                            phoneMask: $.validator.messages.PHONE.phoneMask
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/questions/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                if (result.code === 200) {
	                                    var trackers = new _trackerTracker2['default']();
	                                    trackers.onPMfrmAskQuestion();
	                                    $.prompt.getState('addQuestion').find('.form').html('<p>' + result.html + '</p>');
	                                } else {
	                                    var errorDiv = $('<div/>', {
	                                        'class': 'error form__error-msg',
	                                        text: result.data.error
	                                    });
	                                    $this.find('.form__head-label').after(errorDiv);
	                                }
	                            }
	                        });
	                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                        // чтобы не казалось, будто он совсем пропал с экрана
	                        $.prompt.position();
	                        //$.prompt.close();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	
	    $(document).on('click', '.js-jqi-add-review', function (e) {
	        e.preventDefault();
	        var trackers = new _trackerTracker2['default']();
	        trackers.onPMbtnComment();
	        $.prompt(addReviewPrompt);
	    });
	
	    $(document).on('click', '.js-jqi-add-review-question', function (e) {
	        var elementID = $(this).data('element_id');
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/questions/showPopupForm/?element_id=' + elementID,
	            success: function success(result) {
	                addQuestionPrompt.addQuestion.html = result.html;
	                $.prompt(addQuestionPrompt);
	                var trackers = new _trackerTracker2['default']();
	                trackers.onPMbtnAskQuestion();
	                new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('detail_element_add_question_captcha').init();
	            }
	        });
	    });
	});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexSmartCaptcha = (function () {
	    /*
	    пример контейнера для капчи
	    есть виджет maximaster:widget.yandex.smart.captcha.container
	    <div
	        id="aut_reg_smart_captcha"
	        style="min-width: auto; margin-top: 20px"
	        data-sitekey="ysc1_7Gfc5vSRT9kf7nBgpNatfxUWcZciH0nCpf9gTEidb2202d43"
	        data-widget-id=""
	    ></div>
	    */
	
	    /**
	     * @param elementId - ID контейнера (id="aut_reg_smart_captcha")
	     */
	
	    function YandexSmartCaptcha(elementId) {
	        _classCallCheck(this, YandexSmartCaptcha);
	
	        this.smartCaptcha = window.smartCaptcha || undefined;
	        this.container = $('#' + elementId);
	
	        console.log(elementId);
	    }
	
	    _createClass(YandexSmartCaptcha, [{
	        key: 'init',
	        value: function init() {
	            if (!this.smartCaptcha) {
	                throw new Error('YandexSmartCaptcha error init');
	            }
	
	            var widgetId = this.getWidgetId();
	            if (!widgetId) {
	                console.log('YandexSmartCaptcha: new init');
	
	                if (this.container.length > 0 && this.container[0]) {
	                    widgetId = this.smartCaptcha.render(this.container[0], {
	                        sitekey: this.getSiteKey()
	                    });
	                } else {
	                    console.error('Контейнер капчи не найден:', this.container);
	                }
	                /*let widgetId = this.smartCaptcha.render(this.container[0], {
	                    sitekey: this.getSiteKey()
	                });*/
	
	                this.setWidgetId(widgetId);
	            } else {
	                console.log('YandexSmartCaptcha: reset init');
	                window.smartCaptcha.reset(widgetId);
	            }
	        }
	    }, {
	        key: 'getWidgetId',
	        value: function getWidgetId() {
	            return this.container.attr('data-widget-id');
	        }
	    }, {
	        key: 'setWidgetId',
	        value: function setWidgetId(widgetId) {
	            return this.container.attr('data-widget-id', widgetId);
	        }
	    }, {
	        key: 'getSiteKey',
	        value: function getSiteKey() {
	            return this.container.attr('data-sitekey');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.container.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.container.show();
	        }
	    }, {
	        key: 'getToken',
	        value: function getToken() {
	            return this.container.find('[name="smart-token"]').val();
	        }
	    }]);
	
	    return YandexSmartCaptcha;
	})();

	exports.YandexSmartCaptcha = YandexSmartCaptcha;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(301);
	__webpack_require__(302);
	
	var dropFile = __webpack_require__(306);
	var styledSelect = __webpack_require__(309);
	var ratingStars = __webpack_require__(315);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    $.prompt.setDefaults({
	        promptspeed: 0,
	        overlayspeed: 300,
	        opacity: 0.5,
	        closeText: 'Закрыть',
	        loaded: function loaded() {
	            var $jqi = $('.jqi');
	            $jqi.addClass('shown');
	        },
	        beforeclose: function beforeclose(e) {
	            var $box = $(e.target);
	            $box.find('.jqi').removeClass('shown');
	        },
	        statechanging: function statechanging() {
	            var $form = $('.jqiform');
	
	            //выключить валидатор, чтоб не глючил в момент переключения состояний
	            $form.off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	        },
	        statechanged: function statechanged(event, toStateName) {
	            var $jqi = $('.jqi');
	            var $form = $('.jqiform');
	            var $styledSelects = $jqi.find('.js-styled-select:visible');
	            styledSelect.styleSelects($styledSelects);
	            functions.setMaskedPhone($('.js-masked-phone'));
	
	            if ($form.find('.js-rating-stars').length > 0) {
	                ratingStars.setStars($form.find('.js-rating-stars'));
	            }
	
	            $form.find('.form__input--error').removeClass('form__input--error');
	            $form.find('.form__error-msg').remove();
	
	            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));
	
	            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
	        },
	        closeDelay: 350,
	        buttons: {}
	    });
	
	    $.prompt.setStateDefaults({
	        buttons: {}
	    });
	});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(root.jQuery);
		}
	}(this, function($) {
		'use strict';
	
		// ########################################################################
		// Base object
		// ########################################################################
	
		/**
		* Imp - Impromptu object - passing no params will not open, only return the instance
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return Imp - the instance of this Impromptu object
		*/
		var Imp = function(message, options){
			var t = this;
			t.id = Imp.count++;
	
			Imp.lifo.push(t);
	
			if(message){
				t.open(message, options);
			}
			return t;
		};
	
		// ########################################################################
		// static properties and methods
		// ########################################################################
	
		/**
		* defaults - the default options
		*/
		Imp.defaults = {
			prefix:'jqi',
			classes: {
				box: '',
				fade: '',
				prompt: '',
				form: '',
				close: '',
				title: '',
				message: '',
				buttons: '',
				button: '',
				defaultButton: ''
			},
			title: '',
			closeText: '&times;',
			buttons: {
				Ok: true
			},
			buttonTimeout: 1000,
			loaded: function(e){},
			submit: function(e,v,m,f){},
			close: function(e,v,m,f){},
			beforeclose: function(e,v,m,f){},
			statechanging: function(e, from, to){},
			statechanged: function(e, to){},
			opacity: 0.6,
			zIndex: 999,
			overlayspeed: 'slow',
			promptspeed: 'fast',
			show: 'fadeIn',
			hide: 'fadeOut',
			focus: 0,
			defaultButton: 0,
			useiframe: false,
			top: '15%',
			position: {
				container: null,
				x: null,
				y: null,
				arrow: null,
				width: null
			},
			persistent: true,
			timeout: 0,
			closeDelay: 10,
			states: {},
			initialState: 0,
			state: {
				name: null,
				title: '',
				html: '',
				buttons: {
					Ok: true
				},
				focus: 0,
				defaultButton: 0,
				position: {
					container: null,
					x: null,
					y: null,
					arrow: null,
					width: null
				},
				submit: function(e,v,m,f){
					return true;
				}
			}
		};
	
		/**
		* setDefaults - Sets the default options
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setDefaults = function(o) {
			Imp.defaults = $.extend({}, Imp.defaults, o);
		};
	
		/**
		* setStateDefaults - Sets the default options for a state
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setStateDefaults = function(o) {
			Imp.defaults.state = $.extend({}, Imp.defaults.state, o);
		};
	
		/**
		* @var Int - A counter used to provide a unique ID for new prompts
		*/
		Imp.count = 0;
	
		/**
		* @var Array - An array of Impromptu intances in a LIFO queue (last in first out)
		*/
		Imp.lifo = [];
	
		/**
		* getLast - get the last element from the queue (doesn't pop, just returns)
		* @return Imp - the instance of this Impromptu object or false if queue is empty
		*/
		Imp.getLast = function(){
			var l = Imp.lifo.length;
			return (l > 0)? Imp.lifo[l-1] : false;
		};
	
		/**
		* removeFromStack - remove an element from the lifo stack by its id
		* @param id int - id of the instance to remove
		* @return api - The api of the element removed from the stack or void
		*/
		Imp.removeFromStack = function(id){
			for(var i=Imp.lifo.length-1; i>=0; i--){
				if(Imp.lifo[i].id === id){
					return Imp.lifo.splice(i,1)[0];
				}
			}
		};
	
		// ########################################################################
		// extend our object instance properties and methods
		// ########################################################################
		Imp.prototype = {
	
			/**
			* @var Int - A unique id, simply an autoincremented number
			*/
			id: null,
	
			/**
			* open - Opens the prompt
			* @param message String/Object - String of html or Object of states
			* @param options Object - Options to set the prompt
			* @return Imp - the instance of this Impromptu object
			*/
			open: function(message, options) {
				var t = this;
	
				t.options = $.extend(true,{},Imp.defaults,options);
	
				// Be sure any previous timeouts are destroyed
				if(t.timeout){
					clearTimeout(t.timeout);
				}
				t.timeout = false;
	
				var opts = t.options,
					$body = $(document.body),
					$window = $(window);
	
				//build the box and fade
				var msgbox = '<div class="'+ opts.prefix +'box '+ opts.classes.box +'">';
				if(opts.useiframe && ($('object, applet').length > 0)) {
					msgbox += '<iframe src="javascript:false;" class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></iframe>';
				} else {
					msgbox += '<div class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></div>';
				}
				msgbox += '<div class="'+ opts.prefix +' '+ opts.classes.prompt +'">'+
							'<form action="#" class="'+ opts.prefix +'form '+ opts.classes.form +'">'+
								'<div class="'+ opts.prefix +'close '+ opts.classes.close +'">'+ opts.closeText +'</div>'+
								'<div class="'+ opts.prefix +'states"></div>'+
							'</form>'+
						'</div>'+
					'</div>';
	
				t.jqib = $(msgbox).appendTo($body);
				t.jqi = t.jqib.children('.'+ opts.prefix);
				t.jqif = t.jqib.children('.'+ opts.prefix +'fade');
	
				//if a string was passed, convert to a single state
				if(message.constructor === String){
					message = {
						state0: {
							title: opts.title,
							html: message,
							buttons: opts.buttons,
							position: opts.position,
							focus: opts.focus,
							defaultButton: opts.defaultButton,
							submit: opts.submit
						}
					};
				}
	
				//build the states
				t.options.states = {};
				var k,v;
				for(k in message){
					v = $.extend({},Imp.defaults.state,{name:k},message[k]);
					t.addState(v.name, v);
	
					if(t.currentStateName === ''){
						t.currentStateName = v.name;
					}
				}
	
				//Events
				t.jqi.on('click', '.'+ opts.prefix +'buttons button', function(e){
					var $t = $(this),
						$state = $t.parents('.'+ opts.prefix +'state'),
						statename = $state.data('jqi-name'),
						stateobj = t.options.states[statename],
						msg = $state.children('.'+ opts.prefix +'message'),
						clicked = stateobj.buttons[$t.text()] || stateobj.buttons[$t.html()],
						forminputs = {};
	
					// disable for a moment to prevent multiple clicks
					if(t.options.buttonTimeout > 0){
						t.disableStateButtons(statename);
						setTimeout(function(){
							t.enableStateButtons(statename);
						}, t.options.buttonTimeout);
					}
	
					// if for some reason we couldn't get the value
					if(clicked === undefined){
						for(var i in stateobj.buttons){
							if(stateobj.buttons[i].title === $t.text() || stateobj.buttons[i].title === $t.html()){
								clicked = stateobj.buttons[i].value;
							}
						}
					}
	
					if (clicked === undefined)
					{
						clicked = $t.val();
					}
	
					//collect all form element values from all states.
					$.each(t.jqi.children('form').serializeArray(),function(i,obj){
						if (forminputs[obj.name] === undefined) {
							forminputs[obj.name] = obj.value;
						} else if (typeof forminputs[obj.name] === Array || typeof forminputs[obj.name] === 'object') {
							forminputs[obj.name].push(obj.value);
						} else {
							forminputs[obj.name] = [forminputs[obj.name],obj.value];
						}
					});
	
					// trigger an event
					var promptsubmite = new $.Event('impromptu:submit');
					promptsubmite.stateName = stateobj.name;
					promptsubmite.state = $state;
					$state.trigger(promptsubmite, [clicked, msg, forminputs]);
	
					if(!promptsubmite.isDefaultPrevented()){
						t.close(true, clicked,msg,forminputs);
					}
				});
	
				// if the fade is clicked blink the prompt
				var fadeClicked = function(){
					if(opts.persistent){
						var offset = (opts.top.toString().indexOf('%') >= 0? ($window.height()*(parseInt(opts.top,10)/100)) : parseInt(opts.top,10)),
							top = parseInt(t.jqi.css('top').replace('px',''),10) - offset;
	
						//$window.scrollTop(top);
						$('html,body').animate({ scrollTop: top }, 'fast', function(){
							var i = 0;
							t.jqib.addClass(opts.prefix +'warning');
							var intervalid = setInterval(function(){
								t.jqib.toggleClass(opts.prefix +'warning');
								if(i++ > 1){
									clearInterval(intervalid);
									t.jqib.removeClass(opts.prefix +'warning');
								}
							}, 100);
						});
					}
					else {
						t.close(true);
					}
				};
	
				// listen for esc or tab keys
				var keyDownEventHandler = function(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
	
					//escape key closes
					if(key === 27) {
						fadeClicked();
					}
	
					//enter key pressed trigger the default button if its not on it, ignore if it is a textarea
					if(key === 13){
						var $defBtn = t.getCurrentState().find('.'+ opts.prefix +'defaultbutton');
						var $tgt = $(e.target);
	
						if($tgt.is('textarea,.'+opts.prefix+'button') === false && $defBtn.length > 0){
							e.preventDefault();
							$defBtn.click();
						}
					}
	
					//constrain tabs, tabs should iterate through the state and not leave
					if (key === 9){
						var $inputels = $('input,select,textarea,button',t.getCurrentState());
						var fwd = !e.shiftKey && e.target === $inputels[$inputels.length-1];
						var back = e.shiftKey && e.target === $inputels[0];
						if (fwd || back) {
							setTimeout(function(){
								if (!$inputels){
									return;
								}
								var el = $inputels[back===true ? $inputels.length-1 : 0];
	
								if (el){
									el.focus();
								}
							},10);
							return false;
						}
					}
				};
	
				t.position();
				t.style();
	
				// store copy of the window resize function for interal use only
				t._windowResize = function(e){
					t.position(e);
				};
				$window.resize({ animate: false }, t._windowResize);
	
				t.jqif.click(fadeClicked);
				t.jqi.find('.'+ opts.prefix +'close').click(function(){ t.close(); });
				t.jqi.find('.'+ opts.prefix +'form').submit(function(){ return false; });
				t.jqib.on("keydown",keyDownEventHandler)
							.on('impromptu:loaded', opts.loaded)
							.on('impromptu:beforeclose', opts.beforeclose)
							.on('impromptu:close', opts.close)
							.on('impromptu:statechanging', opts.statechanging)
							.on('impromptu:statechanged', opts.statechanged);
	
				// Show it
				t.jqif[opts.show](opts.overlayspeed);
				t.jqi[opts.show](opts.promptspeed, function(){
	
					t.goToState(
						isNaN(opts.initialState) ? opts.initialState : 
							t.jqi.find('.'+ opts.prefix +'states .'+ opts.prefix +'state').eq(opts.initialState).data('jqi-name')
					);
	
					t.jqib.trigger('impromptu:loaded');
				});
	
				// Timeout
				if(opts.timeout > 0){
					t.timeout = setTimeout(function(){ t.close(true); },opts.timeout);
				}
	
				return t;
			},
	
			/**
			* close - Closes the prompt
			* @param callCallback Function - called when the transition is complete
			* @param clicked String - value of the button clicked (only used internally)
			* @param msg jQuery - The state message body (only used internally)
			* @param formvals Object - key/value pairs of all form field names and values (only used internally)
			* @return Imp - the instance of this Impromptu object
			*/
			close: function(callCallback, clicked, msg, formvals){
				var t = this;
				t.jqib.trigger('impromptu:beforeclose', [clicked,msg,formvals]);
	
				if(t.timeout){
					clearTimeout(t.timeout);
					t.timeout = false;
				}
				Imp.removeFromStack(t.id);
	
				setTimeout(function(){
					if(t.jqib){
	
						t.jqib[t.options.hide](t.options.promptspeed,function(){
	
							t.jqib.trigger('impromptu:close', [clicked,msg,formvals]);
	
							t.jqib.remove();
	
							$(window).off('resize', t._windowResize);
	
							if(typeof callCallback === 'function'){
								callCallback();
							}
						});
					}
	
				}, t.options.closeDelay);
	
				t.currentStateName = "";
				return t;
			},
	
			/**
			* addState - Injects a state into the prompt
			* @param statename String - Name of the state
			* @param stateobj Object - options for the state
			* @param afterState String - selector of the state to insert after
			* @return jQuery - the newly created state
			*/
			addState: function(statename, stateobj, afterState) {
				var t = this,
					state = '',
					$state = null,
					arrow = '',
					title = '',
					opts = t.options,
					pos = $.isFunction(stateobj.position) ? stateobj.position() : stateobj.position,
					$jqistates = t.jqi.find('.'+ opts.prefix +'states'),
					buttons = [],
					showHtml,defbtn,k,v,l,i=0;
	
				stateobj = $.extend({},Imp.defaults.state, {name:statename}, stateobj);
	
				if($.isPlainObject(pos) && pos.arrow !== null){
					arrow = '<div class="'+ opts.prefix + 'arrow '+ opts.prefix + 'arrow'+ pos.arrow +'"></div>';
				}
				if(stateobj.title && stateobj.title !== ''){
					title = '<div class="lead '+ opts.prefix + 'title '+ opts.classes.title +'">'+  stateobj.title +'</div>';
				}
	
				showHtml = stateobj.html;
				if (typeof stateobj.html === 'function') {
					showHtml = 'Error: html function must return text';
				}
	
				state += '<div class="'+ opts.prefix + 'state" data-jqi-name="'+ statename +'">'+
							arrow + title +
							'<div class="'+ opts.prefix +'message '+ opts.classes.message +'">' + showHtml +'</div>'+
							'<div class="'+ opts.prefix +'buttons'+ ($.isEmptyObject(stateobj.buttons)? 'hide ':' ') + opts.classes.buttons +'">';
	
				// state buttons may be in object or array, lets convert objects to arrays
				if($.isArray(stateobj.buttons)){
					buttons = stateobj.buttons;
				}
				else if($.isPlainObject(stateobj.buttons)){
					for(k in stateobj.buttons){
						if(stateobj.buttons.hasOwnProperty(k)){
							buttons.push({ title: k, value: stateobj.buttons[k] });
						}
					}
				}
	
				// iterate over each button and create them
				for(i=0, l=buttons.length; i<l; i++){
					v = buttons[i],
					defbtn = stateobj.focus === i || (isNaN(stateobj.focus) && stateobj.defaultButton === i) ? (opts.prefix + 'defaultbutton ' + opts.classes.defaultButton) : '';
	
					state += '<button class="'+ opts.classes.button +' '+ opts.prefix + 'button '+ defbtn;
	
					if(typeof v.classes !== "undefined"){
						state += ' '+ ($.isArray(v.classes)? v.classes.join(' ') : v.classes) + ' ';
					}
	
					state += '" name="' + opts.prefix + '_' + statename + '_button' + v.title.replace(/[^a-z0-9]+/gi,'') + '" value="' + v.value + '">' + v.title + '</button>';
				}
				
				state += '</div></div>';
	
				$state = $(state).css({display:'none'});
	
				$state.on('impromptu:submit', stateobj.submit);
	
				if(afterState !== undefined){
					t.getState(afterState).after($state);
				}
				else{
					$jqistates.append($state);
				}
	
				t.options.states[statename] = stateobj;
	
				return $state;
			},
	
			/**
			* removeState - Removes a state from the prompt
			* @param state String - Name of the state
			* @param newState String - Name of the state to transition to
			* @return Boolean - returns true on success, false on failure
			*/
			removeState: function(state, newState) {
				var t = this,
					$state = t.getState(state),
					rm = function(){ $state.remove(); };
	
				if($state.length === 0){
					return false;
				}
	
				// transition away from it before deleting
				if($state.css('display') !== 'none'){
					if(newState !== undefined && t.getState(newState).length > 0){
						t.goToState(newState, false, rm);
					}
					else if($state.next().length > 0){
						t.nextState(rm);
					}
					else if($state.prev().length > 0){
						t.prevState(rm);
					}
					else{
						t.close();
					}
				}
				else{
					$state.slideUp('slow', rm);
				}
	
				return true;
			},
	
			/**
			* getApi - Get the api, so you can extract it from $.prompt stack
			* @return jQuery - the prompt
			*/
			getApi: function() {
				return this;
			},
	
			/**
			* getBox - Get the box containing fade and prompt
			* @return jQuery - the prompt
			*/
			getBox: function() {
				return this.jqib;
			},
	
			/**
			* getPrompt - Get the prompt
			* @return jQuery - the prompt
			*/
			getPrompt: function() {
				return this.jqi;
			},
	
			/**
			* getState - Get the state by its name
			* @param statename String - Name of the state
			* @return jQuery - the state
			*/
			getState: function(statename) {
				return this.jqi.find('[data-jqi-name="'+ statename +'"]');
			},
	
			/**
			* getCurrentState - Get the current visible state
			* @return jQuery - the current visible state
			*/
			getCurrentState: function() {
				return this.getState(this.getCurrentStateName());
			},
	
			/**
			* getCurrentStateName - Get the name of the current visible state/substate
			* @return String - the current visible state's name
			*/
			getCurrentStateName: function() {
				return this.currentStateName;
			},
	
			/**
			* disableStateButtons - Disables the buttons in a state
			* @param statename String - Name of the state containing buttons
			* @param buttons Array - Array of button values to disable. By default all are disabled
			* @param enable Boolean - True to enable the buttons instead of disabling (internally use only)
			* @return Void
			*/
			disableStateButtons: function(statename, buttons, enable) {
				var t = this;
	
				if($.isArray(statename)){
					buttons = statename;
					statename = null;
				}
				
				t.getState(statename || t.getCurrentStateName()).find('.'+ t.options.prefix + 'button').each(function(i,btn){
					if(buttons === undefined || $.inArray(btn.value, buttons) !== -1){
						btn.disabled = !enable;
					}
				});
			},
	
			/**
			* enableStateButtons - Enables the buttons in a state
			* @param statename String - Name of the state containing buttons. Defaults to current state
			* @param buttons Array - Array of button values to enable. By default all are enabled
			* @return Void
			*/
			enableStateButtons: function(statename, buttons) {
				this.disableStateButtons(statename, buttons, true);
			},
	
			/**
			* position - Repositions the prompt (Used internally)
			* @return void
			*/
			position: function(e){
				var t = this,
					restoreFx = $.fx.off,
					$state = t.getCurrentState(),
					stateObj = t.options.states[$state.data('jqi-name')],
					pos = stateObj ? $.isFunction(stateObj.position) ? stateObj.position() : stateObj.position : undefined,
					$window = $(window),
					bodyHeight = document.body.scrollHeight, //$(document.body).outerHeight(true),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					height = (bodyHeight > windowHeight) ? bodyHeight : windowHeight,
					scrollTop = parseInt($window.scrollTop(),10),
					top = scrollTop + (t.options.top.toString().indexOf('%') >= 0?
							(windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
				// when resizing the window turn off animation
				if(e !== undefined && e.data.animate === false){
					$.fx.off = true;
				}
	
				t.jqib.css({
					position: "absolute",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
				t.jqif.css({
					position: "fixed",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
	
				// tour positioning
				if(pos && pos.container){
					var offset = $(pos.container).offset(),
						hasScrolled = false;
						
					if($.isPlainObject(offset) && offset.top !== undefined){
						top = (offset.top + pos.y) - (t.options.top.toString().indexOf('%') >= 0? (windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
						t.jqi.css({
							position: "absolute"
						});
						t.jqi.animate({
							top: offset.top + pos.y,
							left: offset.left + pos.x,
							marginLeft: 0,
							width: (pos.width !== undefined)? pos.width : null
						}, function(){
							// if it didn't scroll before, check that the bottom is within view. Since width 
							// is animated we must use the callback before we know the height
							if(!hasScrolled && (offset.top + pos.y + t.jqi.outerHeight(true)) > (scrollTop + windowHeight)){
								$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
								hasScrolled = true;
							}
						});
	
						// scroll if the top is out of the viewing area
						if(top < scrollTop || top > scrollTop + windowHeight){
							$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
							hasScrolled = true;
						}
					}
				}
				// custom state width animation
				else if(pos && pos.width){
					t.jqi.css({
							position: "absolute",
							left: '50%'
						});
					t.jqi.animate({
							top: pos.y || top,
							left: pos.x || '50%',
							marginLeft: ((pos.width/2)*-1),
							width: pos.width
						});
				}
				// standard prompt positioning
				else{
					t.jqi.css({
						position: "absolute",
						top: top,
						left: '50%',//$window.width()/2,
						marginLeft: ((t.jqi.outerWidth(false)/2)*-1)
					});
				}
	
				// restore fx settings
				if(e !== undefined && e.data.animate === false){
					$.fx.off = restoreFx;
				}
			},
	
			/**
			* style - Restyles the prompt (Used internally)
			* @return void
			*/
			style: function(){
				var t = this;
				
				t.jqif.css({
					zIndex: t.options.zIndex,
					display: "none",
					opacity: t.options.opacity
				});
				t.jqi.css({
					zIndex: t.options.zIndex+1,
					display: "none"
				});
				t.jqib.css({
					zIndex: t.options.zIndex
				});
			},
	
			/**
			* goToState - Goto the specified state
			* @param state String - name of the state to transition to
			* @param subState Boolean - true to be a sub state within the currently open state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			goToState: function(state, subState, callback) {
				var t = this,
					$jqi = t.jqi,
					jqiopts = t.options,
					$state = t.getState(state),
					stateobj = jqiopts.states[$state.data('jqi-name')],
					promptstatechanginge = new $.Event('impromptu:statechanging'),
					opts = t.options;
	
				if(stateobj !== undefined){
	
	
					if (typeof stateobj.html === 'function') {
						var contentLaterFunc = stateobj.html;
						$state.find('.' + opts.prefix +'message ').html(contentLaterFunc());
					}
	
					// subState can be ommitted
					if(typeof subState === 'function'){
						callback = subState;
						subState = false;
					}
	
					t.jqib.trigger(promptstatechanginge, [t.getCurrentStateName(), state]);
	
					if(!promptstatechanginge.isDefaultPrevented() && $state.length > 0){
						t.jqi.find('.'+ opts.prefix +'parentstate').removeClass(opts.prefix +'parentstate');
	
						if(subState){ // hide any open substates
							// get rid of any substates
							t.jqi.find('.'+ opts.prefix +'substate').not($state)
								.slideUp(jqiopts.promptspeed)
								.removeClass('.'+ opts.prefix +'substate')
								.find('.'+ opts.prefix +'arrow').hide();
	
							// add parent state class so it can be visible, but blocked
							t.jqi.find('.'+ opts.prefix +'state:visible').addClass(opts.prefix +'parentstate');
	
							// add substate class so we know it will be smaller
							$state.addClass(opts.prefix +'substate');
						}
						else{ // hide any open states
							t.jqi.find('.'+ opts.prefix +'state').not($state)
								.slideUp(jqiopts.promptspeed)
								.find('.'+ opts.prefix +'arrow').hide();
						}
						t.currentStateName = stateobj.name;
	
						$state.slideDown(jqiopts.promptspeed,function(){
							var $t = $(this);
							t.enableStateButtons();
							
							// if focus is a selector, find it, else its button index
							if(typeof(stateobj.focus) === 'string'){
								$t.find(stateobj.focus).eq(0).focus();
							}
							else{
								$t.find('.'+ opts.prefix +'defaultbutton').focus();
							}
	
							$t.find('.'+ opts.prefix +'arrow').show(jqiopts.promptspeed);
	
							if (typeof callback === 'function'){
								t.jqib.on('impromptu:statechanged', callback);
							}
							t.jqib.trigger('impromptu:statechanged', [state]);
							if (typeof callback === 'function'){
								t.jqib.off('impromptu:statechanged', callback);
							}
						});
						if(!subState){
							t.position();
						}
					} // end isDefaultPrevented()	
				}// end stateobj !== undefined
	
				return $state;
			},
	
			/**
			* nextState - Transition to the next state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			nextState: function(callback) {
				var t = this,
					$next = t.getCurrentState().next();
				if($next.length > 0){
					t.goToState( $next.data('jqi-name'), callback );
				}
				return $next;
			},
	
			/**
			* prevState - Transition to the previous state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			prevState: function(callback) {
				var t = this,
					$prev = t.getCurrentState().prev();
				if($prev.length > 0){
					t.goToState( $prev.data('jqi-name'), callback );
				}
				return $prev;
			}
	
		};
	
		// ########################################################################
		// $.prompt will manage a queue of Impromptu instances
		// ########################################################################
	
		/**
		* $.prompt create a new Impromptu instance and push it on the stack of instances
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return jQuery - the jQuery object of the prompt within the modal
		*/
		$.prompt = function(message, options){
			var api = new Imp(message, options);
			return api.jqi;
		};
	
		/**
		* Copy over static methods
		*/
		$.each(Imp, function(k,v){
			$.prompt[k] = v;
		});
	
		/**
		* Create a proxy for accessing all instance methods. The close method pops from queue.
		*/
		$.each(Imp.prototype, function(k,v){
			$.prompt[k] = function(){
				var api = Imp.getLast(); // always use the last instance on the stack
	
				if(api && typeof api[k] === "function"){
					return api[k].apply(api, arguments);
				}
			};
		});
	
		// ########################################################################
		// jQuery Plugin and public access
		// ########################################################################
	
		/**
		* Enable using $('.selector').prompt({});
		* This will grab the html within the prompt as the prompt message
		*/
		$.fn.prompt = function(options){
			if(options === undefined){
				options = {};
			}
			if(options.withDataAndEvents === undefined){
				options.withDataAndEvents = false;
			}
	
			$.prompt($(this).clone(options.withDataAndEvents).html(),options);
		};
	
		/**
		* Export it as Impromptu and $.prompt
		* Can be used from here forth as new Impromptu(states, opts)
		*/
		window.Impromptu = Imp;
	
	}));


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(307);
	
	// reference: https://css-tricks.com/drag-and-drop-file-uploading/
	
	jQuery(function () {
	    // feature detection for drag&drop upload
	    var isAdvancedUpload = (function () {
	        var div = document.createElement('div');
	        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
	    })();
	
	    module.exports.setDropFile = function ($dropContainer) {
	        // applying the effect for every form
	        $dropContainer.each(function () {
	            var $this = $(this),
	                $input = $this.find('input[type="file"]'),
	                $textContainer = $this.find('.drop-file__text'),
	
	            //$errorMsg	 = $this.find( '.box__error span' ),
	            droppedFiles = false,
	                showFiles = function showFiles(files) {
	                var $fileName = $textContainer.find('.drop-file__filename');
	                if ($fileName.length == 0) {
	                    $textContainer.append('<div class="drop-file__filename" />');
	                    $fileName = $textContainer.find('.drop-file__filename');
	                }
	
	                $fileName.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
	            };
	
	            // letting the server side to know we are going to make an Ajax request
	            //$this.append( '<input type="hidden" name="ajax" value="1" />' );
	
	            // automatically submit the form on file select
	            $input.on('change', function (e) {
	                showFiles(e.target.files);
	            });
	
	            // drag&drop files if the feature is available
	            if (isAdvancedUpload) {
	                $this.addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
	                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
	                    // preventing the unwanted behaviours
	                    e.preventDefault();
	                    e.stopPropagation();
	                }).on('dragover dragenter', function () //
	                {
	                    $this.addClass('is-dragover');
	                }).on('dragleave dragend drop', function () {
	                    $this.removeClass('is-dragover');
	                }).on('drop', function (e) {
	                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
	                    showFiles(droppedFiles);
	                });
	            }
	        });
	    };
	});

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);
	__webpack_require__(312);
	
	var styleSelects = function styleSelects($select) {
	    var overwriteOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    $select.each(function () {
	        var $this = $(this);
	
	        var options = {
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        };
	
	        if (!$.isEmptyObject(overwriteOption)) {
	            options = overwriteOption;
	            options.dropdownParent = $this.parent();
	        }
	
	        $this.select2(options).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(313);

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(316);
	
	jQuery(function () {
	    var setStars = function setStars($ratingStars) {
	        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');
	
	        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
	        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;
	
	        $ratingStars.each(function () {
	            var $this = $ratingStars;
	            var $stars = $this.find('.rating-stars__star');
	            var $input = $this.find('.rating-stars__hidden-value');
	
	            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	            if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	            $stars.hover(function () {
	                var $curStar = $(this);
	                $stars.removeClass('rating-stars__star--filled');
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--hover');
	            }, function () {
	                $stars.removeClass('rating-stars__star--hover');
	                $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
	            });
	
	            $stars.click(function () {
	                var $curStar = $(this);
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--filled');
	
	                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                $input.val(curSelectedVal);
	            });
	
	            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;
	
	            $elementRate.hover(function () {
	                var $curStar = $(this);
	                $elementRate.removeClass('rating-stars__star-yellow--filled');
	                $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--hover');
	            }, function () {
	                $elementRate.removeClass('rating-stars__star-yellow--hover');
	                $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
	            });
	        });
	    };
	
	    setStars();
	
	    module.exports.setStars = setStars;
	});
	
	/* При клике на звездочку устаналиваем оценку для элемента */
	$('.js-rating-stars').find('.rating-stars__star-yellow').one('click', function () {
	    var $curStar = $(this);
	    $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--filled');
	    $.ajax({
	        url: '/ajax/action/element_rate/add/',
	        data: 'rating=' + $('.js-rating-stars').find('.rating-stars__star-yellow').filter('.rating-stars__star-yellow--filled').length + '&element_id=' + $('input[name="rate_element_id"]').val() + '&entity_id=' + $('input[name="rate_entity_id"]').val(),
	        success: function success() {
	            $.ajax({
	                url: '/ajax/component/maximaster:element.rate/element/',
	                data: 'ENTITY_ID=' + $('input[name="rate_entity_id"]').val() + '&ELEMENT_ID=' + $('input[name="rate_element_id"]').val(),
	                success: function success(result) {
	                    $('.product-card__element_rate-container').html(result.html);
	                }
	            });
	        }
	    });
	});
	
	/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
	$(document).on('click', '.js-rating-show-auth', function () {
	    if (!$('.jqi').hasClass('shown')) {
	        $('.js-jqi-show-login').trigger('click');
	    }
	});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(319);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    module.exports.formValidateDefaults = {
	        errorPlacement: function errorPlacement(error, element) {
	            element.addClass('form__input--error');
	            element.removeClass('form__input--correct');
	            var $elParent = element.parent();
	            $elParent.removeClass('icon-field--correct');
	            error.addClass('form__error-msg');
	
	            if (element.attr('type') == 'checkbox' || element.attr('type') == 'radio' || element.attr('type') == 'file') {
	                var $formField = element.closest('.form__field');
	                var $headlabel = $formField.find('.prompt__head-label').first();
	                error.addClass('form__error-msg--custom');
	
	                if ($headlabel.length > 0) {
	                    error.insertAfter($headlabel);
	                } else {
	                    $formField.prepend(error);
	                }
	            } else {
	                error.insertBefore($elParent);
	            }
	        },
	        focusInvalid: false,
	        onkeyup: false,
	        success: function success(label, element) {
	            label.remove();
	            var $el = $(element).removeClass('form__input--error');
	            $el.addClass('form__input--correct');
	            var $elParent = $el.parent();
	            $elParent.addClass('icon-field--correct');
	        },
	        errorElement: 'div',
	        onclick: false
	    };
	
	    functions.setMaskedPhone($('.js-masked-phone'));
	    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
	    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
	});

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _getIterator = __webpack_require__(322)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _blocksTrackerEvents = __webpack_require__(131);
	
	var _blocksTrackerEvents2 = _interopRequireDefault(_blocksTrackerEvents);
	
	__webpack_require__(300);
	
	var form = __webpack_require__(318);
	
	var trackers = new _trackerTracker2['default']();
	
	$(function () {
	    var validateParams = _Object$assign({}, form.formValidateDefaults, {
	        rules: {
	            NAME: {
	                required: true
	            },
	            EMAIL: {
	                required: true,
	                email: true,
	                remote: {
	                    url: '/ajax/action/order_oneclick/check_user_person_type/',
	                    type: 'post',
	                    dataType: 'json',
	                    dataFilter: function dataFilter(response) {
	                        var result = false;
	
	                        response = JSON.parse(response);
	                        if (response.data.hasOwnProperty('is_opt')) {
	                            result = !response.data.is_opt;
	                        }
	
	                        return result;
	                    }
	                }
	            },
	            PHONE: {
	                required: true,
	                phoneMask: true
	            }
	        },
	        messages: {
	            NAME: {
	                required: $.validator.messages.NAME.required
	            },
	            EMAIL: {
	                required: $.validator.messages.EMAIL.required,
	                remote: $.validator.messages.EMAIL.remote
	            },
	            PHONE: {
	                required: $.validator.messages.PHONE.required,
	                phoneMask: $.validator.messages.PHONE.phoneMask
	            }
	        },
	        submitHandler: function submitHandler(form) {
	            var params = $(form).serializeObject();
	
	            params.products = [{
	                id: document.querySelector('.js-one-click').dataset.productId,
	                quantity: 1
	            }];
	
	            $(form).find('button[type="submit"]').prop('disabled', true);
	
	            oneClickBuy(params).done(function () {
	                $(form).find('button[type="submit"]').prop('disabled', false);
	            });
	        }
	    });
	
	    function oneClickBuy(params) {
	        return $.post('/ajax/action/order_oneclick/buy/', params, function (response) {
	            if (response.code >= 200 && response.code < 300) {
	                showSuccess(response.data.success);
	                trackers.onOneClickBuyEnd({
	                    fbpixel: {
	                        value: parseInt(document.querySelector('.product-card__price-value').textContent.replace(' ', ''))
	                    }
	                });
	            } else if (response.data.error) {
	                showError(response.data.error);
	            } else {
	                showError('Ошибка создания заказа, пожалуйста перезагрузите страницу!');
	            }
	        }, 'json');
	    }
	
	    function showSuccess(message) {
	        if (popup) {
	            popup.close();
	        }
	        var list = document.getElementsByClassName('breadcrumbs__text');
	        var ierarhy = [];
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = _getIterator(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var item = _step.value;
	
	                ierarhy.push(item.innerHTML);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        var category = ierarhy.slice(2, -1).join('/');
	        var name = ierarhy.slice(-1)[0];
	        trackers.onPMfrm1Click({ param1: category, param2: name });
	        new Impromptu(message, {
	            buttons: {},
	            persistent: false,
	            close: function close(event) {
	                event.preventDefault();
	                document.location.reload('/');
	            }
	        });
	    }
	
	    function showError(error) {
	        error = error.join('<br>');
	        $('.js-oneclick_error').html(error);
	    }
	
	    var popupHtml = '';
	    var popup = null;
	
	    function showPopup(popupHtml) {
	        return new Impromptu(popupHtml, {
	            buttons: {},
	            persistent: false,
	            submit: function submit(event, value, message) {
	                var form = message.closest('form');
	
	                /** revalidate */
	                if (form.data('validator')) {
	                    form.data('validator').destroy();
	                }
	                form.validate(_Object$assign({}, validateParams, {
	                    submitHandler: function submitHandler(form) {
	                        var params = $(form).serializeObject();
	
	                        params.products = [{
	                            id: document.querySelector('.js-one-click').dataset.productId,
	                            quantity: 1
	                        }];
	
	                        $(form).find('button[type="submit"]').prop('disabled', true);
	
	                        oneClickBuy(params).done(function () {
	                            $(form).find('button[type="submit"]').prop('disabled', false);
	                        });
	                    }
	                }));
	
	                event.preventDefault();
	            }
	        });
	    }
	
	    /**
	     * На карточке товара
	     */
	    $('body').on('click', '.js-one-click', function (event) {
	        event.preventDefault();
	        trackers.onOneClickBuyButton();
	        if (popupHtml == '') {
	            $.ajax({
	                url: '/ajax/component/maximaster:order.oneclick/popup/',
	                success: function success(result) {
	                    popupHtml = result.html;
	                    popup = showPopup(popupHtml);
	                    var list = document.getElementsByClassName('breadcrumbs__text');
	                    var ierarhy = [];
	
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = _getIterator(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var item = _step2.value;
	
	                            ierarhy.push(item.innerHTML);
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                                _iterator2['return']();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	
	                    var category = ierarhy.slice(2, -1).join('/');
	                    var name = ierarhy.slice(-1)[0];
	                    trackers.onPMbtn1Click({ param1: category, param2: name });
	                }
	            });
	        } else {
	            popup = showPopup(popupHtml);
	        }
	    });
	
	    /**
	     * В оформлении заказа
	     */
	    if ($('div.checkout').length > 0) {
	        $('.js-oneclick-component > form').validate(_Object$assign({}, validateParams, {
	            submitHandler: function submitHandler(form) {
	                var params = $(form).serializeObject();
	                var ev = new _blocksTrackerEvents2['default']();
	
	                $(form).find('button[type="submit"]').prop('disabled', true);
	
	                ev.onShowOrderStep(2);
	                ev.onShowOrderStep(3);
	                trackers.onOneClickBuyEnd({
	                    fbpixel: {
	                        value: parseInt(document.querySelector('.cart-total__line-value--main').textContent.replace(' ', ''))
	                    }
	                });
	
	                oneClickBuy(params).done(function () {
	                    $(form).find('button[type="submit"]').prop('disabled', false);
	                });
	            }
	        }));
	    }
	});

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(261);
	__webpack_require__(240);
	module.exports = __webpack_require__(324);


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var get = __webpack_require__(255);
	module.exports = __webpack_require__(61).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(326)($);
	__webpack_require__(327)($);
	__webpack_require__(328);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $(document).on('click', '.js-fancybox', function (e) {
	        e.preventDefault();
	        $.fancybox({
	            padding: [29, 25, 29, 25],
	            href: this.href
	        });
	    });
	
	    $(document).on('click', '.js-fancybox-video', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	
	        var padding = [29, 25, 29, 25];
	        if (window.innerWidth < size.tablet) padding = [10, 10, 10, 10];
	
	        $.fancybox({
	            openEffect: 'none',
	            closeEffect: 'none',
	            padding: padding,
	            autoSize: true,
	            aspectRatio: true,
	            autoResize: true,
	            helpers: {
	                media: {}
	            },
	            beforeLoad: function beforeLoad() {
	                var url = $this.attr('href');
	                url = url.replace(new RegExp('watch\\?v=', 'i'), 'v/');
	                url += '?fs=1&autoplay=1';
	                this.href = url;
	            }
	        });
	    });
	});

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/*!
	 * fancyBox - jQuery Plugin
	 * version: 2.1.5 (Fri, 14 Jun 2013)
	 * requires jQuery v1.6 or later
	 *
	 * Examples at http://fancyapps.com/fancybox/
	 * License: www.fancyapps.com/fancybox/#license
	 *
	 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
	 *
	 */
	
	module.exports = function(jQuery) {
	    "use strict";
	
	    var H = jQuery("html"),
	        W = jQuery(window),
	        D = jQuery(document),
	        F = jQuery.fancybox = function() {
	            F.open.apply(this, arguments);
	        },
	        IE = navigator.userAgent.match(/msie/i),
	        didUpdate = null,
	        isTouch = document.createTouch !== undefined,
	
	        isQuery = function(obj) {
	            return obj && obj.hasOwnProperty && obj instanceof jQuery;
	        },
	        isString = function(str) {
	            return str && jQuery.type(str) === "string";
	        },
	        isPercentage = function(str) {
	            return isString(str) && str.indexOf('%') > 0;
	        },
	        isScrollable = function(el) {
	            return (el && !(el.style.overflow && el.style.overflow === 'hidden') && ((el.clientWidth && el.scrollWidth > el.clientWidth) || (el.clientHeight && el.scrollHeight > el.clientHeight)));
	        },
	        getScalar = function(orig, dim) {
	            var value = parseInt(orig, 10) || 0;
	
	            if (dim && isPercentage(orig)) {
	                value = F.getViewport()[dim] / 100 * value;
	            }
	
	            return Math.ceil(value);
	        },
	        getValue = function(value, dim) {
	            return getScalar(value, dim) + 'px';
	        };
	
	    jQuery.extend(F, {
	        // The current version of fancyBox
	        version: '2.1.5',
	
	        defaults: {
	            padding: 15,
	            margin: 20,
	
	            width: 800,
	            height: 600,
	            minWidth: 100,
	            minHeight: 100,
	            maxWidth: 9999,
	            maxHeight: 9999,
	            pixelRatio: 1, // Set to 2 for retina display support
	
	            autoSize: true,
	            autoHeight: false,
	            autoWidth: false,
	
	            autoResize: true,
	            autoCenter: !isTouch,
	            fitToView: true,
	            aspectRatio: false,
	            topRatio: 0.5,
	            leftRatio: 0.5,
	
	            scrolling: 'auto', // 'auto', 'yes' or 'no'
	            wrapCSS: '',
	
	            arrows: true,
	            closeBtn: true,
	            closeClick: false,
	            nextClick: false,
	            mouseWheel: true,
	            autoPlay: false,
	            playSpeed: 3000,
	            preload: 3,
	            modal: false,
	            loop: true,
	
	            ajax: {
	                dataType: 'html',
	                headers: {
	                    'X-fancyBox': true
	                }
	            },
	            iframe: {
	                scrolling: 'auto',
	                preload: true
	            },
	            swf: {
	                wmode: 'transparent',
	                allowfullscreen: 'true',
	                allowscriptaccess: 'always'
	            },
	
	            keys: {
	                next: {
	                    13: 'left', // enter
	                    34: 'up', // page down
	                    39: 'left', // right arrow
	                    40: 'up' // down arrow
	                },
	                prev: {
	                    8: 'right', // backspace
	                    33: 'down', // page up
	                    37: 'right', // left arrow
	                    38: 'down' // up arrow
	                },
	                close: [27], // escape key
	                play: [32], // space - start/stop slideshow
	                toggle: [70] // letter "f" - toggle fullscreen
	            },
	
	            direction: {
	                next: 'left',
	                prev: 'right'
	            },
	
	            scrollOutside: true,
	
	            // Override some properties
	            index: 0,
	            type: null,
	            href: null,
	            content: null,
	            title: null,
	
	            // HTML templates
	            tpl: {
	                wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
	                image: '<img class="fancybox-image" src="{href}" alt="" />',
	                iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (IE ? ' allowtransparency="true"' : '') + '></iframe>',
	                error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
	                closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
	                next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
	                prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
	                loading: '<div id="fancybox-loading"><div></div></div>'
	            },
	
	            // Properties for each animation type
	            // Opening fancyBox
	            openEffect: 'fade', // 'elastic', 'fade' or 'none'
	            openSpeed: 250,
	            openEasing: 'swing',
	            openOpacity: true,
	            openMethod: 'zoomIn',
	
	            // Closing fancyBox
	            closeEffect: 'fade', // 'elastic', 'fade' or 'none'
	            closeSpeed: 250,
	            closeEasing: 'swing',
	            closeOpacity: true,
	            closeMethod: 'zoomOut',
	
	            // Changing next gallery item
	            nextEffect: 'elastic', // 'elastic', 'fade' or 'none'
	            nextSpeed: 250,
	            nextEasing: 'swing',
	            nextMethod: 'changeIn',
	
	            // Changing previous gallery item
	            prevEffect: 'elastic', // 'elastic', 'fade' or 'none'
	            prevSpeed: 250,
	            prevEasing: 'swing',
	            prevMethod: 'changeOut',
	
	            // Enable default helpers
	            helpers: {
	                overlay: true,
	                title: true
	            },
	
	            // Callbacks
	            onCancel: jQuery.noop, // If canceling
	            beforeLoad: jQuery.noop, // Before loading
	            afterLoad: jQuery.noop, // After loading
	            beforeShow: jQuery.noop, // Before changing in current item
	            afterShow: jQuery.noop, // After opening
	            beforeChange: jQuery.noop, // Before changing gallery item
	            beforeClose: jQuery.noop, // Before closing
	            afterClose: jQuery.noop // After closing
	        },
	
	        //Current state
	        group: {}, // Selected group
	        opts: {}, // Group options
	        previous: null, // Previous element
	        coming: null, // Element being loaded
	        current: null, // Currently loaded element
	        isActive: false, // Is activated
	        isOpen: false, // Is currently open
	        isOpened: false, // Have been fully opened at least once
	
	        wrap: null,
	        skin: null,
	        outer: null,
	        inner: null,
	
	        player: {
	            timer: null,
	            isActive: false
	        },
	
	        // Loaders
	        ajaxLoad: null,
	        imgPreload: null,
	
	        // Some collections
	        transitions: {},
	        helpers: {},
	
	        /*
	         *	Static methods
	         */
	
	        open: function(group, opts) {
	            if (!group) {
	                return;
	            }
	
	            if (!jQuery.isPlainObject(opts)) {
	                opts = {};
	            }
	
	            // Close if already active
	            if (false === F.close(true)) {
	                return;
	            }
	
	            // Normalize group
	            if (!jQuery.isArray(group)) {
	                group = isQuery(group) ? jQuery(group).get() : [group];
	            }
	
	            // Recheck if the type of each element is `object` and set content type (image, ajax, etc)
	            jQuery.each(group, function(i, element) {
	                var obj = {},
	                    href,
	                    title,
	                    content,
	                    type,
	                    rez,
	                    hrefParts,
	                    selector;
	
	                if (jQuery.type(element) === "object") {
	                    // Check if is DOM element
	                    if (element.nodeType) {
	                        element = jQuery(element);
	                    }
	
	                    if (isQuery(element)) {
	                        obj = {
	                            href: element.data('fancybox-href') || element.attr('href'),
	                            title: jQuery('<div/>').text(element.data('fancybox-title') || element.attr('title') || '').html(),
	                            isDom: true,
	                            element: element
	                        };
	
	                        if (jQuery.metadata) {
	                            jQuery.extend(true, obj, element.metadata());
	                        }
	
	                    } else {
	                        obj = element;
	                    }
	                }
	
	                href = opts.href || obj.href || (isString(element) ? element : null);
	                title = opts.title !== undefined ? opts.title : obj.title || '';
	
	                content = opts.content || obj.content;
	                type = content ? 'html' : (opts.type || obj.type);
	
	                if (!type && obj.isDom) {
	                    type = element.data('fancybox-type');
	
	                    if (!type) {
	                        rez = element.prop('class').match(/fancybox\.(\w+)/);
	                        type = rez ? rez[1] : null;
	                    }
	                }
	
	                if (isString(href)) {
	                    // Try to guess the content type
	                    if (!type) {
	                        if (F.isImage(href)) {
	                            type = 'image';
	
	                        } else if (F.isSWF(href)) {
	                            type = 'swf';
	
	                        } else if (href.charAt(0) === '#') {
	                            type = 'inline';
	
	                        } else if (isString(element)) {
	                            type = 'html';
	                            content = element;
	                        }
	                    }
	
	                    // Split url into two pieces with source url and content selector, e.g,
	                    // "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
	                    if (type === 'ajax') {
	                        hrefParts = href.split(/\s+/, 2);
	                        href = hrefParts.shift();
	                        selector = hrefParts.shift();
	                    }
	                }
	
	                if (!content) {
	                    if (type === 'inline') {
	                        if (href) {
	                            content = jQuery(isString(href) ? href.replace(/.*(?=#[^\s]+$)/, '') : href); //strip for ie7
	
	                        } else if (obj.isDom) {
	                            content = element;
	                        }
	
	                    } else if (type === 'html') {
	                        content = href;
	
	                    } else if (!type && !href && obj.isDom) {
	                        type = 'inline';
	                        content = element;
	                    }
	                }
	
	                jQuery.extend(obj, {
	                    href: href,
	                    type: type,
	                    content: content,
	                    title: title,
	                    selector: selector
	                });
	
	                group[i] = obj;
	            });
	
	            // Extend the defaults
	            F.opts = jQuery.extend(true, {}, F.defaults, opts);
	
	            // All options are merged recursive except keys
	            if (opts.keys !== undefined) {
	                F.opts.keys = opts.keys ? jQuery.extend({}, F.defaults.keys, opts.keys) : false;
	            }
	
	            F.group = group;
	
	            return F._start(F.opts.index);
	        },
	
	        // Cancel image loading or abort ajax request
	        cancel: function() {
	            var coming = F.coming;
	
	            if (coming && false === F.trigger('onCancel')) {
	                return;
	            }
	
	            F.hideLoading();
	
	            if (!coming) {
	                return;
	            }
	
	            if (F.ajaxLoad) {
	                F.ajaxLoad.abort();
	            }
	
	            F.ajaxLoad = null;
	
	            if (F.imgPreload) {
	                F.imgPreload.onload = F.imgPreload.onerror = null;
	            }
	
	            if (coming.wrap) {
	                coming.wrap.stop(true, true).trigger('onReset').remove();
	            }
	
	            F.coming = null;
	
	            // If the first item has been canceled, then clear everything
	            if (!F.current) {
	                F._afterZoomOut(coming);
	            }
	        },
	
	        // Start closing animation if is open; remove immediately if opening/closing
	        close: function(event) {
	            F.cancel();
	
	            if (false === F.trigger('beforeClose')) {
	                return;
	            }
	
	            F.unbindEvents();
	
	            if (!F.isActive) {
	                return;
	            }
	
	            if (!F.isOpen || event === true) {
	                jQuery('.fancybox-wrap').stop(true).trigger('onReset').remove();
	
	                F._afterZoomOut();
	
	            } else {
	                F.isOpen = F.isOpened = false;
	                F.isClosing = true;
	
	                jQuery('.fancybox-item, .fancybox-nav').remove();
	
	                F.wrap.stop(true, true).removeClass('fancybox-opened');
	
	                F.transitions[F.current.closeMethod]();
	            }
	        },
	
	        // Manage slideshow:
	        //   jQuery.fancybox.play(); - toggle slideshow
	        //   jQuery.fancybox.play( true ); - start
	        //   jQuery.fancybox.play( false ); - stop
	        play: function(action) {
	            var clear = function() {
	                    clearTimeout(F.player.timer);
	                },
	                set = function() {
	                    clear();
	
	                    if (F.current && F.player.isActive) {
	                        F.player.timer = setTimeout(F.next, F.current.playSpeed);
	                    }
	                },
	                stop = function() {
	                    clear();
	
	                    D.unbind('.player');
	
	                    F.player.isActive = false;
	
	                    F.trigger('onPlayEnd');
	                },
	                start = function() {
	                    if (F.current && (F.current.loop || F.current.index < F.group.length - 1)) {
	                        F.player.isActive = true;
	
	                        D.bind({
	                            'onCancel.player beforeClose.player': stop,
	                            'onUpdate.player': set,
	                            'beforeLoad.player': clear
	                        });
	
	                        set();
	
	                        F.trigger('onPlayStart');
	                    }
	                };
	
	            if (action === true || (!F.player.isActive && action !== false)) {
	                start();
	            } else {
	                stop();
	            }
	        },
	
	        // Navigate to next gallery item
	        next: function(direction) {
	            var current = F.current;
	
	            if (current) {
	                if (!isString(direction)) {
	                    direction = current.direction.next;
	                }
	
	                F.jumpto(current.index + 1, direction, 'next');
	            }
	        },
	
	        // Navigate to previous gallery item
	        prev: function(direction) {
	            var current = F.current;
	
	            if (current) {
	                if (!isString(direction)) {
	                    direction = current.direction.prev;
	                }
	
	                F.jumpto(current.index - 1, direction, 'prev');
	            }
	        },
	
	        // Navigate to gallery item by index
	        jumpto: function(index, direction, router) {
	            var current = F.current;
	
	            if (!current) {
	                return;
	            }
	
	            index = getScalar(index);
	
	            F.direction = direction || current.direction[(index >= current.index ? 'next' : 'prev')];
	            F.router = router || 'jumpto';
	
	            if (current.loop) {
	                if (index < 0) {
	                    index = current.group.length + (index % current.group.length);
	                }
	
	                index = index % current.group.length;
	            }
	
	            if (current.group[index] !== undefined) {
	                F.cancel();
	
	                F._start(index);
	            }
	        },
	
	        // Center inside viewport and toggle position type to fixed or absolute if needed
	        reposition: function(e, onlyAbsolute) {
	            var current = F.current,
	                wrap = current ? current.wrap : null,
	                pos;
	
	            if (wrap) {
	                pos = F._getPosition(onlyAbsolute);
	
	                if (e && e.type === 'scroll') {
	                    delete pos.position;
	
	                    wrap.stop(true, true).animate(pos, 200);
	
	                } else {
	                    wrap.css(pos);
	
	                    current.pos = jQuery.extend({}, current.dim, pos);
	                }
	            }
	        },
	
	        update: function(e) {
	            var type = (e && e.originalEvent && e.originalEvent.type),
	                anyway = !type || type === 'orientationchange';
	
	            if (anyway) {
	                clearTimeout(didUpdate);
	
	                didUpdate = null;
	            }
	
	            if (!F.isOpen || didUpdate) {
	                return;
	            }
	
	            didUpdate = setTimeout(function() {
	                var current = F.current;
	
	                if (!current || F.isClosing) {
	                    return;
	                }
	
	                F.wrap.removeClass('fancybox-tmp');
	
	                if (anyway || type === 'load' || (type === 'resize' && current.autoResize)) {
	                    F._setDimension();
	                }
	
	                if (!(type === 'scroll' && current.canShrink)) {
	                    F.reposition(e);
	                }
	
	                F.trigger('onUpdate');
	
	                didUpdate = null;
	
	            }, (anyway && !isTouch ? 0 : 300));
	        },
	
	        // Shrink content to fit inside viewport or restore if resized
	        toggle: function(action) {
	            if (F.isOpen) {
	                F.current.fitToView = jQuery.type(action) === "boolean" ? action : !F.current.fitToView;
	
	                // Help browser to restore document dimensions
	                if (isTouch) {
	                    F.wrap.removeAttr('style').addClass('fancybox-tmp');
	
	                    F.trigger('onUpdate');
	                }
	
	                F.update();
	            }
	        },
	
	        hideLoading: function() {
	            D.unbind('.loading');
	
	            jQuery('#fancybox-loading').remove();
	        },
	
	        showLoading: function() {
	            var el, viewport;
	
	            F.hideLoading();
	
	            el = jQuery(F.opts.tpl.loading).click(F.cancel).appendTo('body');
	
	            // If user will press the escape-button, the request will be canceled
	            D.bind('keydown.loading', function(e) {
	                if ((e.which || e.keyCode) === 27) {
	                    e.preventDefault();
	
	                    F.cancel();
	                }
	            });
	
	            if (!F.defaults.fixed) {
	                viewport = F.getViewport();
	
	                el.css({
	                    position: 'absolute',
	                    top: (viewport.h * 0.5) + viewport.y,
	                    left: (viewport.w * 0.5) + viewport.x
	                });
	            }
	
	            F.trigger('onLoading');
	        },
	
	        getViewport: function() {
	            var locked = (F.current && F.current.locked) || false,
	                rez = {
	                    x: W.scrollLeft(),
	                    y: W.scrollTop()
	                };
	
	            if (locked && locked.length) {
	                rez.w = locked[0].clientWidth;
	                rez.h = locked[0].clientHeight;
	
	            } else {
	                // See http://bugs.jquery.com/ticket/6724
	                rez.w = isTouch && window.innerWidth ? window.innerWidth : W.width();
	                rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height();
	            }
	
	            return rez;
	        },
	
	        // Unbind the keyboard / clicking actions
	        unbindEvents: function() {
	            if (F.wrap && isQuery(F.wrap)) {
	                F.wrap.unbind('.fb');
	            }
	
	            D.unbind('.fb');
	            W.unbind('.fb');
	        },
	
	        bindEvents: function() {
	            var current = F.current,
	                keys;
	
	            if (!current) {
	                return;
	            }
	
	            // Changing document height on iOS devices triggers a 'resize' event,
	            // that can change document height... repeating infinitely
	            W.bind('orientationchange.fb' + (isTouch ? '' : ' resize.fb') + (current.autoCenter && !current.locked ? ' scroll.fb' : ''), F.update);
	
	            keys = current.keys;
	
	            if (keys) {
	                D.bind('keydown.fb', function(e) {
	                    var code = e.which || e.keyCode,
	                        target = e.target || e.srcElement;
	
	                    // Skip esc key if loading, because showLoading will cancel preloading
	                    if (code === 27 && F.coming) {
	                        return false;
	                    }
	
	                    // Ignore key combinations and key events within form elements
	                    if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || jQuery(target).is('[contenteditable]')))) {
	                        jQuery.each(keys, function(i, val) {
	                            if (current.group.length > 1 && val[code] !== undefined) {
	                                F[i](val[code]);
	
	                                e.preventDefault();
	                                return false;
	                            }
	
	                            if (jQuery.inArray(code, val) > -1) {
	                                F[i]();
	
	                                e.preventDefault();
	                                return false;
	                            }
	                        });
	                    }
	                });
	            }
	
	            if (jQuery.fn.mousewheel && current.mouseWheel) {
	                F.wrap.bind('mousewheel.fb', function(e, delta, deltaX, deltaY) {
	                    var target = e.target || null,
	                        parent = jQuery(target),
	                        canScroll = false;
	
	                    while (parent.length) {
	                        if (canScroll || parent.is('.fancybox-skin') || parent.is('.fancybox-wrap')) {
	                            break;
	                        }
	
	                        canScroll = isScrollable(parent[0]);
	                        parent = jQuery(parent).parent();
	                    }
	
	                    if (delta !== 0 && !canScroll) {
	                        if (F.group.length > 1 && !current.canShrink) {
	                            if (deltaY > 0 || deltaX > 0) {
	                                F.prev(deltaY > 0 ? 'down' : 'left');
	
	                            } else if (deltaY < 0 || deltaX < 0) {
	                                F.next(deltaY < 0 ? 'up' : 'right');
	                            }
	
	                            e.preventDefault();
	                        }
	                    }
	                });
	            }
	        },
	
	        trigger: function(event, o) {
	            var ret, obj = o || F.coming || F.current;
	
	            if (obj) {
	                if (jQuery.isFunction(obj[event])) {
	                    ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1));
	                }
	
	                if (ret === false) {
	                    return false;
	                }
	
	                if (obj.helpers) {
	                    jQuery.each(obj.helpers, function(helper, opts) {
	                        if (opts && F.helpers[helper] && jQuery.isFunction(F.helpers[helper][event])) {
	                            F.helpers[helper][event](jQuery.extend(true, {}, F.helpers[helper].defaults, opts), obj);
	                        }
	                    });
	                }
	            }
	
	            D.trigger(event);
	        },
	
	        isImage: function(str) {
	            return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
	        },
	
	        isSWF: function(str) {
	            return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i);
	        },
	
	        _start: function(index) {
	            var coming = {},
	                obj,
	                href,
	                type,
	                margin,
	                padding;
	
	            index = getScalar(index);
	            obj = F.group[index] || null;
	
	            if (!obj) {
	                return false;
	            }
	
	            coming = jQuery.extend(true, {}, F.opts, obj);
	
	            // Convert margin and padding properties to array - top, right, bottom, left
	            margin = coming.margin;
	            padding = coming.padding;
	
	            if (jQuery.type(margin) === 'number') {
	                coming.margin = [margin, margin, margin, margin];
	            }
	
	            if (jQuery.type(padding) === 'number') {
	                coming.padding = [padding, padding, padding, padding];
	            }
	
	            // 'modal' propery is just a shortcut
	            if (coming.modal) {
	                jQuery.extend(true, coming, {
	                    closeBtn: false,
	                    closeClick: false,
	                    nextClick: false,
	                    arrows: false,
	                    mouseWheel: false,
	                    keys: null,
	                    helpers: {
	                        overlay: {
	                            closeClick: false
	                        }
	                    }
	                });
	            }
	
	            // 'autoSize' property is a shortcut, too
	            if (coming.autoSize) {
	                coming.autoWidth = coming.autoHeight = true;
	            }
	
	            if (coming.width === 'auto') {
	                coming.autoWidth = true;
	            }
	
	            if (coming.height === 'auto') {
	                coming.autoHeight = true;
	            }
	
	            /*
	             * Add reference to the group, so it`s possible to access from callbacks, example:
	             * afterLoad : function() {
	             *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
	             * }
	             */
	
	            coming.group = F.group;
	            coming.index = index;
	
	            // Give a chance for callback or helpers to update coming item (type, title, etc)
	            F.coming = coming;
	
	            if (false === F.trigger('beforeLoad')) {
	                F.coming = null;
	
	                return;
	            }
	
	            type = coming.type;
	            href = coming.href;
	
	            if (!type) {
	                F.coming = null;
	
	                //If we can not determine content type then drop silently or display next/prev item if looping through gallery
	                if (F.current && F.router && F.router !== 'jumpto') {
	                    F.current.index = index;
	
	                    return F[F.router](F.direction);
	                }
	
	                return false;
	            }
	
	            F.isActive = true;
	
	            if (type === 'image' || type === 'swf') {
	                coming.autoHeight = coming.autoWidth = false;
	                coming.scrolling = 'visible';
	            }
	
	            if (type === 'image') {
	                coming.aspectRatio = true;
	            }
	
	            if (type === 'iframe' && isTouch) {
	                coming.scrolling = 'scroll';
	            }
	
	            // Build the neccessary markup
	            coming.wrap = jQuery(coming.tpl.wrap).addClass('fancybox-' + (isTouch ? 'mobile' : 'desktop') + ' fancybox-type-' + type + ' fancybox-tmp ' + coming.wrapCSS).appendTo(coming.parent || 'body');
	
	            jQuery.extend(coming, {
	                skin: jQuery('.fancybox-skin', coming.wrap),
	                outer: jQuery('.fancybox-outer', coming.wrap),
	                inner: jQuery('.fancybox-inner', coming.wrap)
	            });
	
	            jQuery.each(["Top", "Right", "Bottom", "Left"], function(i, v) {
	                coming.skin.css('padding' + v, getValue(coming.padding[i]));
	            });
	
	            F.trigger('onReady');
	
	            // Check before try to load; 'inline' and 'html' types need content, others - href
	            if (type === 'inline' || type === 'html') {
	                if (!coming.content || !coming.content.length) {
	                    return F._error('content');
	                }
	
	            } else if (!href) {
	                return F._error('href');
	            }
	
	            if (type === 'image') {
	                F._loadImage();
	
	            } else if (type === 'ajax') {
	                F._loadAjax();
	
	            } else if (type === 'iframe') {
	                F._loadIframe();
	
	            } else {
	                F._afterLoad();
	            }
	        },
	
	        _error: function(type) {
	            jQuery.extend(F.coming, {
	                type: 'html',
	                autoWidth: true,
	                autoHeight: true,
	                minWidth: 0,
	                minHeight: 0,
	                scrolling: 'no',
	                hasError: type,
	                content: F.coming.tpl.error
	            });
	
	            F._afterLoad();
	        },
	
	        _loadImage: function() {
	            // Reset preload image so it is later possible to check "complete" property
	            var img = F.imgPreload = new Image();
	
	            img.onload = function() {
	                this.onload = this.onerror = null;
	
	                F.coming.width = this.width / F.opts.pixelRatio;
	                F.coming.height = this.height / F.opts.pixelRatio;
	
	                F._afterLoad();
	            };
	
	            img.onerror = function() {
	                this.onload = this.onerror = null;
	
	                F._error('image');
	            };
	
	            img.src = F.coming.href;
	
	            if (img.complete !== true) {
	                F.showLoading();
	            }
	        },
	
	        _loadAjax: function() {
	            var coming = F.coming;
	
	            F.showLoading();
	
	            F.ajaxLoad = jQuery.ajax(jQuery.extend({}, coming.ajax, {
	                url: coming.href,
	                error: function(jqXHR, textStatus) {
	                    if (F.coming && textStatus !== 'abort') {
	                        F._error('ajax', jqXHR);
	
	                    } else {
	                        F.hideLoading();
	                    }
	                },
	                success: function(data, textStatus) {
	                    if (textStatus === 'success') {
	                        coming.content = data;
	
	                        F._afterLoad();
	                    }
	                }
	            }));
	        },
	
	        _loadIframe: function() {
	            var coming = F.coming,
	                iframe = jQuery(coming.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
	                .attr('scrolling', isTouch ? 'auto' : coming.iframe.scrolling)
	                .attr('src', coming.href);
	
	            // This helps IE
	            jQuery(coming.wrap).bind('onReset', function() {
	                try {
	                    jQuery(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
	                } catch (e) {}
	            });
	
	            if (coming.iframe.preload) {
	                F.showLoading();
	
	                iframe.one('load', function() {
	                    jQuery(this).data('ready', 1);
	
	                    // iOS will lose scrolling if we resize
	                    if (!isTouch) {
	                        jQuery(this).bind('load.fb', F.update);
	                    }
	
	                    // Without this trick:
	                    //   - iframe won't scroll on iOS devices
	                    //   - IE7 sometimes displays empty iframe
	                    jQuery(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();
	
	                    F._afterLoad();
	                });
	            }
	
	            coming.content = iframe.appendTo(coming.inner);
	
	            if (!coming.iframe.preload) {
	                F._afterLoad();
	            }
	        },
	
	        _preloadImages: function() {
	            var group = F.group,
	                current = F.current,
	                len = group.length,
	                cnt = current.preload ? Math.min(current.preload, len - 1) : 0,
	                item,
	                i;
	
	            for (i = 1; i <= cnt; i += 1) {
	                item = group[(current.index + i) % len];
	
	                if (item.type === 'image' && item.href) {
	                    new Image().src = item.href;
	                }
	            }
	        },
	
	        _afterLoad: function() {
	            var coming = F.coming,
	                previous = F.current,
	                placeholder = 'fancybox-placeholder',
	                current,
	                content,
	                type,
	                scrolling,
	                href,
	                embed;
	
	            F.hideLoading();
	
	            if (!coming || F.isActive === false) {
	                return;
	            }
	
	            if (false === F.trigger('afterLoad', coming, previous)) {
	                coming.wrap.stop(true).trigger('onReset').remove();
	
	                F.coming = null;
	
	                return;
	            }
	
	            if (previous) {
	                F.trigger('beforeChange', previous);
	
	                previous.wrap.stop(true).removeClass('fancybox-opened')
	                    .find('.fancybox-item, .fancybox-nav')
	                    .remove();
	            }
	
	            F.unbindEvents();
	
	            current = coming;
	            content = coming.content;
	            type = coming.type;
	            scrolling = coming.scrolling;
	
	            jQuery.extend(F, {
	                wrap: current.wrap,
	                skin: current.skin,
	                outer: current.outer,
	                inner: current.inner,
	                current: current,
	                previous: previous
	            });
	
	            href = current.href;
	
	            switch (type) {
	                case 'inline':
	                case 'ajax':
	                case 'html':
	                    if (current.selector) {
	                        content = jQuery('<div>').html(content).find(current.selector);
	
	                    } else if (isQuery(content)) {
	                        if (!content.data(placeholder)) {
	                            content.data(placeholder, jQuery('<div class="' + placeholder + '"></div>').insertAfter(content).hide());
	                        }
	
	                        content = content.show().detach();
	
	                        current.wrap.bind('onReset', function() {
	                            if (jQuery(this).find(content).length) {
	                                content.hide().replaceAll(content.data(placeholder)).data(placeholder, false);
	                            }
	                        });
	                    }
	                    break;
	
	                case 'image':
	                    content = current.tpl.image.replace(/\{href\}/g, href);
	                    break;
	
	                case 'swf':
	                    content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
	                    embed = '';
	
	                    jQuery.each(current.swf, function(name, val) {
	                        content += '<param name="' + name + '" value="' + val + '"></param>';
	                        embed += ' ' + name + '="' + val + '"';
	                    });
	
	                    content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + '></embed></object>';
	                    break;
	            }
	
	            if (!(isQuery(content) && content.parent().is(current.inner))) {
	                current.inner.append(content);
	            }
	
	            // Give a chance for helpers or callbacks to update elements
	            F.trigger('beforeShow');
	
	            // Set scrolling before calculating dimensions
	            current.inner.css('overflow', scrolling === 'yes' ? 'scroll' : (scrolling === 'no' ? 'hidden' : scrolling));
	
	            // Set initial dimensions and start position
	            F._setDimension();
	
	            F.reposition();
	
	            F.isOpen = false;
	            F.coming = null;
	
	            F.bindEvents();
	
	            if (!F.isOpened) {
	                jQuery('.fancybox-wrap').not(current.wrap).stop(true).trigger('onReset').remove();
	
	            } else if (previous.prevMethod) {
	                F.transitions[previous.prevMethod]();
	            }
	
	            F.transitions[F.isOpened ? current.nextMethod : current.openMethod]();
	
	            F._preloadImages();
	        },
	
	        _setDimension: function() {
	            var viewport = F.getViewport(),
	                steps = 0,
	                canShrink = false,
	                canExpand = false,
	                wrap = F.wrap,
	                skin = F.skin,
	                inner = F.inner,
	                current = F.current,
	                width = current.width,
	                height = current.height,
	                minWidth = current.minWidth,
	                minHeight = current.minHeight,
	                maxWidth = current.maxWidth,
	                maxHeight = current.maxHeight,
	                scrolling = current.scrolling,
	                scrollOut = current.scrollOutside ? current.scrollbarWidth : 0,
	                margin = current.margin,
	                wMargin = getScalar(margin[1] + margin[3]),
	                hMargin = getScalar(margin[0] + margin[2]),
	                wPadding,
	                hPadding,
	                wSpace,
	                hSpace,
	                origWidth,
	                origHeight,
	                origMaxWidth,
	                origMaxHeight,
	                ratio,
	                width_,
	                height_,
	                maxWidth_,
	                maxHeight_,
	                iframe,
	                body;
	
	            // Reset dimensions so we could re-check actual size
	            wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');
	
	            wPadding = getScalar(skin.outerWidth(true) - skin.width());
	            hPadding = getScalar(skin.outerHeight(true) - skin.height());
	
	            // Any space between content and viewport (margin, padding, border, title)
	            wSpace = wMargin + wPadding;
	            hSpace = hMargin + hPadding;
	
	            origWidth = isPercentage(width) ? (viewport.w - wSpace) * getScalar(width) / 100 : width;
	            origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;
	
	            if (current.type === 'iframe') {
	                iframe = current.content;
	
	                if (current.autoHeight && iframe.data('ready') === 1) {
	                    try {
	                        if (iframe[0].contentWindow.document.location) {
	                            inner.width(origWidth).height(9999);
	
	                            body = iframe.contents().find('body');
	
	                            if (scrollOut) {
	                                body.css('overflow-x', 'hidden');
	                            }
	
	                            origHeight = body.outerHeight(true);
	                        }
	
	                    } catch (e) {}
	                }
	
	            } else if (current.autoWidth || current.autoHeight) {
	                inner.addClass('fancybox-tmp');
	
	                // Set width or height in case we need to calculate only one dimension
	                if (!current.autoWidth) {
	                    inner.width(origWidth);
	                }
	
	                if (!current.autoHeight) {
	                    inner.height(origHeight);
	                }
	
	                if (current.autoWidth) {
	                    origWidth = inner.width();
	                }
	
	                if (current.autoHeight) {
	                    origHeight = inner.height();
	                }
	
	                inner.removeClass('fancybox-tmp');
	            }
	
	            width = getScalar(origWidth);
	            height = getScalar(origHeight);
	
	            ratio = origWidth / origHeight;
	
	            // Calculations for the content
	            minWidth = getScalar(isPercentage(minWidth) ? getScalar(minWidth, 'w') - wSpace : minWidth);
	            maxWidth = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, 'w') - wSpace : maxWidth);
	
	            minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, 'h') - hSpace : minHeight);
	            maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, 'h') - hSpace : maxHeight);
	
	            // These will be used to determine if wrap can fit in the viewport
	            origMaxWidth = maxWidth;
	            origMaxHeight = maxHeight;
	
	            if (current.fitToView) {
	                maxWidth = Math.min(viewport.w - wSpace, maxWidth);
	                maxHeight = Math.min(viewport.h - hSpace, maxHeight);
	            }
	
	            maxWidth_ = viewport.w - wMargin;
	            maxHeight_ = viewport.h - hMargin;
	
	            if (current.aspectRatio) {
	                if (width > maxWidth) {
	                    width = maxWidth;
	                    height = getScalar(width / ratio);
	                }
	
	                if (height > maxHeight) {
	                    height = maxHeight;
	                    width = getScalar(height * ratio);
	                }
	
	                if (width < minWidth) {
	                    width = minWidth;
	                    height = getScalar(width / ratio);
	                }
	
	                if (height < minHeight) {
	                    height = minHeight;
	                    width = getScalar(height * ratio);
	                }
	
	            } else {
	                width = Math.max(minWidth, Math.min(width, maxWidth));
	
	                if (current.autoHeight && current.type !== 'iframe') {
	                    inner.width(width);
	
	                    height = inner.height();
	                }
	
	                height = Math.max(minHeight, Math.min(height, maxHeight));
	            }
	
	            // Try to fit inside viewport (including the title)
	            if (current.fitToView) {
	                inner.width(width).height(height);
	
	                wrap.width(width + wPadding);
	
	                // Real wrap dimensions
	                width_ = wrap.width();
	                height_ = wrap.height();
	
	                if (current.aspectRatio) {
	                    while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight) {
	                        if (steps++ > 19) {
	                            break;
	                        }
	
	                        height = Math.max(minHeight, Math.min(maxHeight, height - 10));
	                        width = getScalar(height * ratio);
	
	                        if (width < minWidth) {
	                            width = minWidth;
	                            height = getScalar(width / ratio);
	                        }
	
	                        if (width > maxWidth) {
	                            width = maxWidth;
	                            height = getScalar(width / ratio);
	                        }
	
	                        inner.width(width).height(height);
	
	                        wrap.width(width + wPadding);
	
	                        width_ = wrap.width();
	                        height_ = wrap.height();
	                    }
	
	                } else {
	                    width = Math.max(minWidth, Math.min(width, width - (width_ - maxWidth_)));
	                    height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)));
	                }
	            }
	
	            if (scrollOut && scrolling === 'auto' && height < origHeight && (width + wPadding + scrollOut) < maxWidth_) {
	                width += scrollOut;
	            }
	
	            inner.width(width).height(height);
	
	            wrap.width(width + wPadding);
	
	            width_ = wrap.width();
	            height_ = wrap.height();
	
	            canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
	            canExpand = current.aspectRatio ? (width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight) : ((width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight));
	
	            jQuery.extend(current, {
	                dim: {
	                    width: getValue(width_),
	                    height: getValue(height_)
	                },
	                origWidth: origWidth,
	                origHeight: origHeight,
	                canShrink: canShrink,
	                canExpand: canExpand,
	                wPadding: wPadding,
	                hPadding: hPadding,
	                wrapSpace: height_ - skin.outerHeight(true),
	                skinSpace: skin.height() - height
	            });
	
	            if (!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand) {
	                inner.height('auto');
	            }
	        },
	
	        _getPosition: function(onlyAbsolute) {
	            var current = F.current,
	                viewport = F.getViewport(),
	                margin = current.margin,
	                width = F.wrap.width() + margin[1] + margin[3],
	                height = F.wrap.height() + margin[0] + margin[2],
	                rez = {
	                    position: 'absolute',
	                    top: margin[0],
	                    left: margin[3]
	                };
	
	            if (current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w) {
	                rez.position = 'fixed';
	
	            } else if (!current.locked) {
	                rez.top += viewport.y;
	                rez.left += viewport.x;
	            }
	
	            rez.top = getValue(Math.max(rez.top, rez.top + ((viewport.h - height) * current.topRatio)));
	            rez.left = getValue(Math.max(rez.left, rez.left + ((viewport.w - width) * current.leftRatio)));
	
	            return rez;
	        },
	
	        _afterZoomIn: function() {
	            var current = F.current;
	
	            if (!current) {
	                return;
	            }
	
	            F.isOpen = F.isOpened = true;
	
	            F.wrap.css('overflow', 'visible').addClass('fancybox-opened').hide().show(0);
	
	            F.update();
	
	            // Assign a click event
	            if (current.closeClick || (current.nextClick && F.group.length > 1)) {
	                F.inner.css('cursor', 'pointer').bind('click.fb', function(e) {
	                    if (!jQuery(e.target).is('a') && !jQuery(e.target).parent().is('a')) {
	                        e.preventDefault();
	
	                        F[current.closeClick ? 'close' : 'next']();
	                    }
	                });
	            }
	
	            // Create a close button
	            if (current.closeBtn) {
	                jQuery(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb', function(e) {
	                    e.preventDefault();
	
	                    F.close();
	                });
	            }
	
	            // Create navigation arrows
	            if (current.arrows && F.group.length > 1) {
	                if (current.loop || current.index > 0) {
	                    jQuery(current.tpl.prev).appendTo(F.outer).bind('click.fb', F.prev);
	                }
	
	                if (current.loop || current.index < F.group.length - 1) {
	                    jQuery(current.tpl.next).appendTo(F.outer).bind('click.fb', F.next);
	                }
	            }
	
	            F.trigger('afterShow');
	
	            // Stop the slideshow if this is the last item
	            if (!current.loop && current.index === current.group.length - 1) {
	
	                F.play(false);
	
	            } else if (F.opts.autoPlay && !F.player.isActive) {
	                F.opts.autoPlay = false;
	
	                F.play(true);
	            }
	        },
	
	        _afterZoomOut: function(obj) {
	            obj = obj || F.current;
	
	            jQuery('.fancybox-wrap').trigger('onReset').remove();
	
	            jQuery.extend(F, {
	                group: {},
	                opts: {},
	                router: false,
	                current: null,
	                isActive: false,
	                isOpened: false,
	                isOpen: false,
	                isClosing: false,
	                wrap: null,
	                skin: null,
	                outer: null,
	                inner: null
	            });
	
	            F.trigger('afterClose', obj);
	        }
	    });
	
	    /*
	     *	Default transitions
	     */
	
	    F.transitions = {
	        getOrigPosition: function() {
	            var current = F.current,
	                element = current.element,
	                orig = current.orig,
	                pos = {},
	                width = 50,
	                height = 50,
	                hPadding = current.hPadding,
	                wPadding = current.wPadding,
	                viewport = F.getViewport();
	
	            if (!orig && current.isDom && element.is(':visible')) {
	                orig = element.find('img:first');
	
	                if (!orig.length) {
	                    orig = element;
	                }
	            }
	
	            if (isQuery(orig)) {
	                pos = orig.offset();
	
	                if (orig.is('img')) {
	                    width = orig.outerWidth();
	                    height = orig.outerHeight();
	                }
	
	            } else {
	                pos.top = viewport.y + (viewport.h - height) * current.topRatio;
	                pos.left = viewport.x + (viewport.w - width) * current.leftRatio;
	            }
	
	            if (F.wrap.css('position') === 'fixed' || current.locked) {
	                pos.top -= viewport.y;
	                pos.left -= viewport.x;
	            }
	
	            pos = {
	                top: getValue(pos.top - hPadding * current.topRatio),
	                left: getValue(pos.left - wPadding * current.leftRatio),
	                width: getValue(width + wPadding),
	                height: getValue(height + hPadding)
	            };
	
	            return pos;
	        },
	
	        step: function(now, fx) {
	            var ratio,
	                padding,
	                value,
	                prop = fx.prop,
	                current = F.current,
	                wrapSpace = current.wrapSpace,
	                skinSpace = current.skinSpace;
	
	            if (prop === 'width' || prop === 'height') {
	                ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);
	
	                if (F.isClosing) {
	                    ratio = 1 - ratio;
	                }
	
	                padding = prop === 'width' ? current.wPadding : current.hPadding;
	                value = now - padding;
	
	                F.skin[prop](getScalar(prop === 'width' ? value : value - (wrapSpace * ratio)));
	                F.inner[prop](getScalar(prop === 'width' ? value : value - (wrapSpace * ratio) - (skinSpace * ratio)));
	            }
	        },
	
	        zoomIn: function() {
	            var current = F.current,
	                startPos = current.pos,
	                effect = current.openEffect,
	                elastic = effect === 'elastic',
	                endPos = jQuery.extend({
	                    opacity: 1
	                }, startPos);
	
	            // Remove "position" property that breaks older IE
	            delete endPos.position;
	
	            if (elastic) {
	                startPos = this.getOrigPosition();
	
	                if (current.openOpacity) {
	                    startPos.opacity = 0.1;
	                }
	
	            } else if (effect === 'fade') {
	                startPos.opacity = 0.1;
	            }
	
	            F.wrap.css(startPos).animate(endPos, {
	                duration: effect === 'none' ? 0 : current.openSpeed,
	                easing: current.openEasing,
	                step: elastic ? this.step : null,
	                complete: F._afterZoomIn
	            });
	        },
	
	        zoomOut: function() {
	            var current = F.current,
	                effect = current.closeEffect,
	                elastic = effect === 'elastic',
	                endPos = {
	                    opacity: 0.1
	                };
	
	            if (elastic) {
	                endPos = this.getOrigPosition();
	
	                if (current.closeOpacity) {
	                    endPos.opacity = 0.1;
	                }
	            }
	
	            F.wrap.animate(endPos, {
	                duration: effect === 'none' ? 0 : current.closeSpeed,
	                easing: current.closeEasing,
	                step: elastic ? this.step : null,
	                complete: F._afterZoomOut
	            });
	        },
	
	        changeIn: function() {
	            var current = F.current,
	                effect = current.nextEffect,
	                startPos = current.pos,
	                endPos = {
	                    opacity: 1
	                },
	                direction = F.direction,
	                distance = 200,
	                field;
	
	            startPos.opacity = 0.1;
	
	            if (effect === 'elastic') {
	                field = direction === 'down' || direction === 'up' ? 'top' : 'left';
	
	                if (direction === 'down' || direction === 'right') {
	                    startPos[field] = getValue(getScalar(startPos[field]) - distance);
	                    endPos[field] = '+=' + distance + 'px';
	
	                } else {
	                    startPos[field] = getValue(getScalar(startPos[field]) + distance);
	                    endPos[field] = '-=' + distance + 'px';
	                }
	            }
	
	            // Workaround for http://bugs.jquery.com/ticket/12273
	            if (effect === 'none') {
	                F._afterZoomIn();
	
	            } else {
	                F.wrap.css(startPos).animate(endPos, {
	                    duration: current.nextSpeed,
	                    easing: current.nextEasing,
	                    complete: F._afterZoomIn
	                });
	            }
	        },
	
	        changeOut: function() {
	            var previous = F.previous,
	                effect = previous.prevEffect,
	                endPos = {
	                    opacity: 0.1
	                },
	                direction = F.direction,
	                distance = 200;
	
	            if (effect === 'elastic') {
	                endPos[direction === 'down' || direction === 'up' ? 'top' : 'left'] = (direction === 'up' || direction === 'left' ? '-' : '+') + '=' + distance + 'px';
	            }
	
	            previous.wrap.animate(endPos, {
	                duration: effect === 'none' ? 0 : previous.prevSpeed,
	                easing: previous.prevEasing,
	                complete: function() {
	                    jQuery(this).trigger('onReset').remove();
	                }
	            });
	        }
	    };
	
	    /*
	     *	Overlay helper
	     */
	
	    F.helpers.overlay = {
	        defaults: {
	            closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
	            speedOut: 200, // duration of fadeOut animation
	            showEarly: true, // indicates if should be opened immediately or wait until the content is ready
	            css: {}, // custom CSS properties
	            locked: !isTouch, // if true, the content will be locked into overlay
	            fixed: true // if false, the overlay CSS position property will not be set to "fixed"
	        },
	
	        overlay: null, // current handle
	        fixed: false, // indicates if the overlay has position "fixed"
	        el: jQuery('html'), // element that contains "the lock"
	
	        // Public methods
	        create: function(opts) {
	            var parent;
	
	            opts = jQuery.extend({}, this.defaults, opts);
	
	            if (this.overlay) {
	                this.close();
	            }
	
	            parent = F.coming ? F.coming.parent : opts.parent;
	
	            this.overlay = jQuery('<div class="fancybox-overlay"></div>').appendTo(parent && parent.length ? parent : 'body');
	            this.fixed = false;
	
	            if (opts.fixed && F.defaults.fixed) {
	                this.overlay.addClass('fancybox-overlay-fixed');
	
	                this.fixed = true;
	            }
	        },
	
	        open: function(opts) {
	            var that = this;
	
	            opts = jQuery.extend({}, this.defaults, opts);
	
	            if (this.overlay) {
	                this.overlay.unbind('.overlay').width('auto').height('auto');
	
	            } else {
	                this.create(opts);
	            }
	
	            if (!this.fixed) {
	                W.bind('resize.overlay', jQuery.proxy(this.update, this));
	
	                this.update();
	            }
	
	            if (opts.closeClick) {
	                this.overlay.bind('click.overlay', function(e) {
	                    if (jQuery(e.target).hasClass('fancybox-overlay')) {
	                        if (F.isActive) {
	                            F.close();
	                        } else {
	                            that.close();
	                        }
	
	                        return false;
	                    }
	                });
	            }
	
	            this.overlay.css(opts.css).show();
	        },
	
	        close: function() {
	            W.unbind('resize.overlay');
	
	            if (this.el.hasClass('fancybox-lock')) {
	                jQuery('.fancybox-margin').removeClass('fancybox-margin');
	
	                this.el.removeClass('fancybox-lock');
	
	                W.scrollTop(this.scrollV).scrollLeft(this.scrollH);
	            }
	
	            jQuery('.fancybox-overlay').remove().hide();
	
	            jQuery.extend(this, {
	                overlay: null,
	                fixed: false
	            });
	        },
	
	        // Private, callbacks
	
	        update: function() {
	            var width = '100%', offsetWidth;
	
	            // Reset width/height so it will not mess
	            this.overlay.width(width).height('100%');
	
	            // jQuery does not return reliable result for IE
	            if (IE) {
	                offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);
	
	                if (D.width() > offsetWidth) {
	                    width = D.width();
	                }
	
	            } else if (D.width() > W.width()) {
	                width = D.width();
	            }
	
	            this.overlay.width(width).height(D.height());
	        },
	
	        // This is where we can manipulate DOM, because later it would cause iframes to reload
	        onReady: function(opts, obj) {
	            var overlay = this.overlay;
	
	            jQuery('.fancybox-overlay').stop(true, true);
	
	            if (!overlay) {
	                this.create(opts);
	            }
	
	            if (opts.locked && this.fixed && obj.fixed) {
	                obj.locked = this.overlay.append(obj.wrap);
	                obj.fixed = false;
	            }
	
	            if (opts.showEarly === true) {
	                this.beforeShow.apply(this, arguments);
	            }
	        },
	
	        beforeShow: function(opts, obj) {
	            if (obj.locked && !this.el.hasClass('fancybox-lock')) {
	                if (this.fixPosition !== false) {
	                    jQuery('*').filter(function() {
	                        return (jQuery(this).css('position') === 'fixed' && !jQuery(this).hasClass("fancybox-overlay") && !jQuery(this).hasClass("fancybox-wrap"));
	                    }).addClass('fancybox-margin');
	                }
	
	                this.el.addClass('fancybox-margin');
	
	                this.scrollV = W.scrollTop();
	                this.scrollH = W.scrollLeft();
	
	                this.el.addClass('fancybox-lock');
	
	                W.scrollTop(this.scrollV).scrollLeft(this.scrollH);
	            }
	
	            this.open(opts);
	        },
	
	        onUpdate: function() {
	            if (!this.fixed) {
	                this.update();
	            }
	        },
	
	        afterClose: function(opts) {
	            // Remove overlay if exists and fancyBox is not opening
	            // (e.g., it is not being open using afterClose callback)
	            if (this.overlay && !F.coming) {
	                this.overlay.fadeOut(opts.speedOut, jQuery.proxy(this.close, this));
	            }
	        }
	    };
	
	    /*
	     *	Title helper
	     */
	
	    F.helpers.title = {
	        defaults: {
	            type: 'float', // 'float', 'inside', 'outside' or 'over',
	            position: 'bottom' // 'top' or 'bottom'
	        },
	
	        beforeShow: function(opts) {
	            var current = F.current,
	                text = current.title,
	                type = opts.type,
	                title,
	                target;
	
	            if (jQuery.isFunction(text)) {
	                text = text.call(current.element, current);
	            }
	
	            if (!isString(text) || jQuery.trim(text) === '') {
	                return;
	            }
	
	            title = jQuery('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '</div>');
	
	            switch (type) {
	                case 'inside':
	                    target = F.skin;
	                    break;
	
	                case 'outside':
	                    target = F.wrap;
	                    break;
	
	                case 'over':
	                    target = F.inner;
	                    break;
	
	                default: // 'float'
	                    target = F.skin;
	
	                    title.appendTo('body');
	
	                    if (IE) {
	                        title.width(title.width());
	                    }
	
	                    title.wrapInner('<span class="child"></span>');
	
	                    //Increase bottom margin so this title will also fit into viewport
	                    F.current.margin[2] += Math.abs(getScalar(title.css('margin-bottom')));
	                    break;
	            }
	
	            title[(opts.position === 'top' ? 'prependTo' : 'appendTo')](target);
	        }
	    };
	
	    // jQuery plugin initialization
	    jQuery.fn.fancybox = function(options) {
	        var index,
	            that = jQuery(this),
	            selector = this.selector || '',
	            run = function(e) {
	                var what = jQuery(this).blur(), idx = index, relType, relVal;
	
	                if (!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is('.fancybox-wrap')) {
	                    relType = options.groupAttr || 'data-fancybox-group';
	                    relVal = what.attr(relType);
	
	                    if (!relVal) {
	                        relType = 'rel';
	                        relVal = what.get(0)[relType];
	                    }
	
	                    if (relVal && relVal !== '' && relVal !== 'nofollow') {
	                        what = selector.length ? jQuery(selector) : that;
	                        what = what.filter('[' + relType + '="' + relVal + '"]');
	                        idx = what.index(this);
	                    }
	
	                    options.index = idx;
	
	                    // Stop an event from bubbling if everything is fine
	                    if (F.open(what, options) !== false) {
	                        e.preventDefault();
	                    }
	                }
	            };
	
	        options = options || {};
	        index = options.index || 0;
	
	        if (!selector || options.live === false) {
	            that.unbind('click.fb-start').bind('click.fb-start', run);
	
	        } else {
	            D.undelegate(selector, 'click.fb-start').delegate(selector + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', run);
	        }
	
	        this.filter('[data-fancybox-start=1]').trigger('click');
	
	        return this;
	    };
	
	    // Tests that need a body at doc ready
	    D.ready(function() {
	        var w1, w2;
	
	        if (jQuery.scrollbarWidth === undefined) {
	            // http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
	            jQuery.scrollbarWidth = function() {
	                var parent = jQuery('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
	                    child = parent.children(),
	                    width = child.innerWidth() - child.height(99).innerWidth();
	
	                parent.remove();
	
	                return width;
	            };
	        }
	
	        if (jQuery.support.fixedPosition === undefined) {
	            jQuery.support.fixedPosition = (function() {
	                var elem = jQuery('<div style="position:fixed;top:20px;"></div>').appendTo('body'),
	                    fixed = (elem[0].offsetTop === 20 || elem[0].offsetTop === 15);
	
	                elem.remove();
	
	                return fixed;
	            }());
	        }
	
	        jQuery.extend(F.defaults, {
	            scrollbarWidth: jQuery.scrollbarWidth(),
	            fixed: jQuery.support.fixedPosition,
	            parent: jQuery('body')
	        });
	
	        //Get real width of page scroll-bar
	        w1 = jQuery(window).width();
	
	        H.addClass('fancybox-lock-test');
	
	        w2 = jQuery(window).width();
	
	        H.removeClass('fancybox-lock-test');
	
	        jQuery("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
	    });
	}


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/*!
	 * Media helper for fancyBox
	 * version: 1.0.6 (Fri, 14 Jun 2013)
	 * @requires fancyBox v2.0 or later
	 *
	 * Usage:
	 *     $(".fancybox").fancybox({
	 *         helpers : {
	 *             media: true
	 *         }
	 *     });
	 *
	 * Set custom URL parameters:
	 *     $(".fancybox").fancybox({
	 *         helpers : {
	 *             media: {
	 *                 youtube : {
	 *                     params : {
	 *                         autoplay : 0
	 *                     }
	 *                 }
	 *             }
	 *         }
	 *     });
	 *
	 * Or:
	 *     $(".fancybox").fancybox({,
	 *         helpers : {
	 *             media: true
	 *         },
	 *         youtube : {
	 *             autoplay: 0
	 *         }
	 *     });
	 *
	 *  Supports:
	 *
	 *      Youtube
	 *          http://www.youtube.com/watch?v=opj24KnzrWo
	 *          http://www.youtube.com/embed/opj24KnzrWo
	 *          http://youtu.be/opj24KnzrWo
	 *			http://www.youtube-nocookie.com/embed/opj24KnzrWo
	 *      Vimeo
	 *          http://vimeo.com/40648169
	 *          http://vimeo.com/channels/staffpicks/38843628
	 *          http://vimeo.com/groups/surrealism/videos/36516384
	 *          http://player.vimeo.com/video/45074303
	 *      Metacafe
	 *          http://www.metacafe.com/watch/7635964/dr_seuss_the_lorax_movie_trailer/
	 *          http://www.metacafe.com/watch/7635964/
	 *      Dailymotion
	 *          http://www.dailymotion.com/video/xoytqh_dr-seuss-the-lorax-premiere_people
	 *      Twitvid
	 *          http://twitvid.com/QY7MD
	 *      Twitpic
	 *          http://twitpic.com/7p93st
	 *      Instagram
	 *          http://instagr.am/p/IejkuUGxQn/
	 *          http://instagram.com/p/IejkuUGxQn/
	 *      Google maps
	 *          http://maps.google.com/maps?q=Eiffel+Tower,+Avenue+Gustave+Eiffel,+Paris,+France&t=h&z=17
	 *          http://maps.google.com/?ll=48.857995,2.294297&spn=0.007666,0.021136&t=m&z=16
	 *          http://maps.google.com/?ll=48.859463,2.292626&spn=0.000965,0.002642&t=m&z=19&layer=c&cbll=48.859524,2.292532&panoid=YJ0lq28OOy3VT2IqIuVY0g&cbp=12,151.58,,0,-15.56
	 */
	
	module.exports = function($) {
	    "use strict";
	
	    //Shortcut for fancyBox object
	    var F = $.fancybox,
	        format = function(url, rez, params) {
	            params = params || '';
	
	            if ($.type(params) === "object") {
	                params = $.param(params, true);
	            }
	
	            $.each(rez, function(key, value) {
	                url = url.replace('$' + key, value || '');
	            });
	
	            if (params.length) {
	                url += (url.indexOf('?') > 0 ? '&' : '?') + params;
	            }
	
	            return url;
	        };
	
	    //Add helper object
	    F.helpers.media = {
	        defaults: {
	            youtube: {
	                matcher: /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i,
	                params: {
	                    autoplay: 1,
	                    autohide: 1,
	                    fs: 1,
	                    rel: 0,
	                    hd: 1,
	                    wmode: 'opaque',
	                    enablejsapi: 1
	                },
	                type: 'iframe',
	                url: '//www.youtube.com/embed/$3'
	            },
	            vimeo: {
	                matcher: /(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/,
	                params: {
	                    autoplay: 1,
	                    hd: 1,
	                    show_title: 1,
	                    show_byline: 1,
	                    show_portrait: 0,
	                    fullscreen: 1
	                },
	                type: 'iframe',
	                url: '//player.vimeo.com/video/$1'
	            },
	            metacafe: {
	                matcher: /metacafe.com\/(?:watch|fplayer)\/([\w\-]{1,10})/,
	                params: {
	                    autoPlay: 'yes'
	                },
	                type: 'swf',
	                url: function(rez, params, obj) {
	                    obj.swf.flashVars = 'playerVars=' + $.param(params, true);
	
	                    return '//www.metacafe.com/fplayer/' + rez[1] + '/.swf';
	                }
	            },
	            dailymotion: {
	                matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
	                params: {
	                    additionalInfos: 0,
	                    autoStart: 1
	                },
	                type: 'swf',
	                url: '//www.dailymotion.com/swf/video/$1'
	            },
	            twitvid: {
	                matcher: /twitvid\.com\/([a-zA-Z0-9_\-\?\=]+)/i,
	                params: {
	                    autoplay: 0
	                },
	                type: 'iframe',
	                url: '//www.twitvid.com/embed.php?guid=$1'
	            },
	            twitpic: {
	                matcher: /twitpic\.com\/(?!(?:place|photos|events)\/)([a-zA-Z0-9\?\=\-]+)/i,
	                type: 'image',
	                url: '//twitpic.com/show/full/$1/'
	            },
	            instagram: {
	                matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
	                type: 'image',
	                url: '//$1/p/$2/media/?size=l'
	            },
	            google_maps: {
	                matcher: /maps\.google\.([a-z]{2,3}(\.[a-z]{2})?)\/(\?ll=|maps\?)(.*)/i,
	                type: 'iframe',
	                url: function(rez) {
	                    return '//maps.google.' + rez[1] + '/' + rez[3] + '' + rez[4] + '&output=' + (rez[4].indexOf('layer=c') > 0 ? 'svembed' : 'embed');
	                }
	            }
	        },
	
	        beforeLoad: function(opts, obj) {
	            var url = obj.href || '',
	                type = false,
	                what,
	                item,
	                rez,
	                params;
	
	            for (what in opts) {
	                if (opts.hasOwnProperty(what)) {
	                    item = opts[what];
	                    rez = url.match(item.matcher);
	
	                    if (rez) {
	                        type = item.type;
	                        params = $.extend(true, {}, item.params, obj[what] || ($.isPlainObject(opts[what]) ? opts[what].params : null));
	
	                        url = $.type(item.url) === "function" ? item.url.call(this, rez, params, obj) : format(item.url, rez, params);
	
	                        break;
	                    }
	                }
	            }
	
	            if (type) {
	                obj.href = url;
	                obj.type = type;
	
	                obj.autoHeight = false;
	            }
	        }
	    };
	}


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(300);
	
	jQuery(function () {
	    var specialGiftPromptHtml = '<div class="special-action">' + '<img class="special-action__bg-img" src="local/assets/img/bg-product-gift.jpg" alt="Спецпредложение" />' + '<div class="special-action__content">' + '<div class="special-action__title">Спецпредложение</div>' + '<div class="special-action__box">' + 'Купите это чудесное масло сегодня и получите подарок, точно такое же масло, но с просроченным сроком годности!' + '</div>' + '<a href="#" class="special-action__btn btn-def btn-def--pink">Абсолютно <span class="special-action__btn-b">бесплатно!</span></a>' + '</div>' + '</div>';
	
	    //какое-нибудь условие для показа рекламного всплывающего блока
	    if (window.location.href.indexOf('product2.html') != -1) {
	        setTimeout(function () {
	            $.prompt(specialGiftPromptHtml, {
	                buttons: {},
	                persistent: false, //чтобы можно было закрыть при клике по оверлею
	                classes: {
	                    prompt: 'prompt--large',
	                    form: 'prompt__form-special',
	                    close: 'jqiclose--cross'
	                }
	            });
	        }, 1000);
	    }
	});

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(149);
	__webpack_require__(343);
	__webpack_require__(306);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(344);
	
	jQuery(function () {
	    $(document).on('change', '.js-attach-file-input-controll', function () {
	        var isSelected = $(this).val().length > 0;
	        var selectedBox = $(this).next();
	        if (isSelected) {
	            selectedBox.find('span').text('[' + $(this)[0].files.length + ']');
	        }
	    });
	});

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery(function () {
	    function onYaPayLoad() {
	        var renderElement = $('#yandex_split_detail_product');
	
	        if (renderElement.length === 0) {
	            return;
	        }
	
	        var price = renderElement.attr('data-price') || 0;
	        var YaPay = window.YaPay;
	
	        // Данные платежа
	        var paymentData = {
	            env: 'PRODUCTION',
	            version: 4,
	            currencyCode: 'RUB',
	            merchantId: 'de5da2c1-12db-4179-b02a-11b580eab658',
	            totalAmount: price,
	            availablePaymentMethods: ['SPLIT']
	        };
	
	        function onPayButtonClick() {}
	
	        // eslint-disable-next-line no-unused-vars
	        function onFormOpenError(reason) {}
	
	        // Создаем платежную сессию
	        YaPay.createSession(paymentData, { onPayButtonClick: onPayButtonClick, onFormOpenError: onFormOpenError }).then(function (paymentSession) {
	            paymentSession.mountWidget(document.querySelector('#yandex_split_detail_product'), {
	                widgetType: YaPay.WidgetType.Ultimate,
	                widgetTheme: YaPay.WidgetTheme.Light,
	                borderRadius: 10,
	                padding: YaPay.WidgetPaddingType.Default,
	                withOutline: true,
	                widgetBackground: YaPay.WidgetBackgroundType.Saturated,
	                hideWidgetHeader: false,
	                widgetSize: YaPay.WidgetSize.Medium
	            });
	        })['catch'](function (err) {
	            console.log(err);
	        });
	    }
	
	    setTimeout(function () {
	        onYaPayLoad();
	    }, 1000);
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/catalog_product.9ccd45c91749567a321e.js